<template>
  <div class="preview-table">
    <div class="mb-10">
      <el-select v-model="batch_config.active_name" size="mini" class="mr-10" placeholder="请选择批量操作" @change="refreshTable">
        <el-option
          v-for="item in batch_config.options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-button type="success" size="mini" @click="() => onBatch()">批量操作</el-button>
    </div>
    <app-table
      ref="preview_table_ref"
      v-loading="dynamic_table_config.loading"
      v-horizontal-scroll="'always'"
      :is-current-page="false"
      :table-props="{ ...dynamic_table_config.props }"
      :table-key="dynamic_table_config.header"
      :page-size="2000"
      :table-list-data="dynamic_table_config.data"
      :check="true"
      check-key="id"
      :is-reserve-checked="true"
      @select-tr="selectionChange"
    >
      <template #empty>
        <el-empty description="暂无数据" />
      </template>
    </app-table>
    <!-- 表单编辑 -->
    <el-dialog
      v-if="edit_dialog_config.is_show"
      :title="edit_dialog_config.title"
      width="600px"
      :visible.sync="edit_dialog_config.is_show"
      append-to-body
    >
      <app-form
        v-if="edit_dialog_config.is_show"
        default-label-width="170px"
        :form-data="edit_dialog_config.form_data"
        @confirm="confirmEditDialog"
        @cancel="cancelEditDialog"
      >
        <template #custom="{ form_item, form_key }">
          <component
            :is="edit_dialog_config.getters.getDynamicComponentName()"
            v-if="edit_dialog_config.is_show"
            :form-key="form_key"
            :form-item="form_item"
            :init-ops="init_ops"
            v-bind="edit_dialog_config.getters.getDynamicComponentProps()"
          />
        </template>
      </app-form>
    </el-dialog>
    <!-- 数据弹窗 -->
    <el-dialog
      v-if="data_dialog_config.is_show"
      :title="data_dialog_config.title"
      :visible.sync="data_dialog_config.is_show"
      append-to-body
    >
      <component
        :is="data_dialog_config.map_component_name[data_dialog_config.active_name]()"
        v-if="data_dialog_config.is_show"
        v-loading="data_dialog_config.is_loading"
        v-bind="data_dialog_config.getters.getProps(data_dialog_config.active_name)"
        @confirm="onDataDialogConfirm"
        @cancel="onDataDialogCancel"
      />
    </el-dialog>
    <!-- 批量操作 -->
    <el-dialog
      v-if="batch_config.is_show"
      :title="batch_config.title"
      width="600px"
      :visible.sync="batch_config.is_show"
      append-to-body
    >
      <component
        :is="batch_config.component_name_map[batch_config.active_name]"
        v-if="batch_config.is_show"
        v-bind="batch_config.getters.getProps(batch_config.active_name)"
        @confirm="onBatchConfirm"
        @cancel="onBatchCancel"
      />
    </el-dialog>
  </div>
</template>

<script>
import { data_sharing_mixin } from '@/views/fusion/investment/intelligence-create/mixins/data-sharing';
import { getCampaignConfig, getCreativeConfig } from '@/views/fusion/investment/intelligence-create/model/form';
import { notEmptyValidator } from '@/views/fusion/investment/intelligence-create/tools/form/validator';
import { useGetChannelDetails } from '@/views/fusion/investment/intelligence-create/hooks';
import { clone, transformSchema, hasOwnProperty } from '@/utils';
import { isNumber, isNotNullAndUnDef, isArray } from '@/utils/is';
import { getDeliveryContentApi } from '@/api/tool/delivery-content';
import { getConvertApi } from '@/api/tool/convert';
import { getConvertGoalListApi } from '@/api/tool/convert-goal';
import { getDeepConvertGoalApi } from '@/api/tool/deep-convert-goal';
import { transformObjectToOptions, getChannelsWithEditableCode, getChannelsWithEditableSite } from '@/tools';
import { CHANNEL_INTERFACE_TYPE, OPTIONS_TYPE } from '@/enums';
import { getChannelPackageApi, pullChannelPackageApi } from '@/api/tool/channel-package';
import calculator from '@/utils/calculator';

export default {
  components: {
    'app-table': () => import('@/components/app-table'),
    'app-form': () => import('@/components/app-form'),
    'title-view-form': () => import('@/views/fusion/investment/intelligence-create/components/main-view/components/assign-form/title/view-form/index.vue'),
    'step-form': () => import('@/views/fusion/investment/intelligence-create/components/main-view/components/step-form/index.vue'),
    'material-preview': () => import('@/views/auxiliary/material-library/components/material-preview'),
    'material-store': () => import('@/views/fusion/investment/intelligence-create/components/main-view/components/preview-table/components/material-store/index.vue'),
    'conversion-event': () => import('@/views/fusion/investment/intelligence-create/components/main-view/components/step-form/components/campaign-config/budget-and-bid-form/components/conversion/index.vue'),
    'channel-package': () => import('@/views/fusion/investment/intelligence-create/components/main-view/components/preview-table/components/channel-package/index.vue'),
    'channel-code': () => import('@/views/fusion/investment/intelligence-create/components/main-view/components/preview-table/components/channel-code/index.vue'),
    'sites': () => import('@/views/fusion/investment/intelligence-create/components/main-view/components/preview-table/components/sites/index.vue'),
    'multiple-conversion-event': () => import('@/views/fusion/investment/intelligence-create/components/main-view/components/step-form/components/campaign-config/budget-and-bid-form/components/multiple-conversion/src/conversion-event/index.vue'),
  },
  mixins: [data_sharing_mixin],
  props: {
    // 表格数据源
    dataSources: {
      type: Array,
      required: true,
    },
    // 表单分配的数据列表，用于获取素材配置列表、标题配置列表、落地页配置列表、广告定向配置列表
    formAssignData: {
      type: Object,
      required: true,
    },
    // 选项枚举值
    optionsEnumsVal: {
      type: Object,
      required: true,
    },
    // 选项值
    optionsVal: {
      type: Object,
      required: true,
    },
    /** 是否为添加创意 */
    isAddCreative: {
      type: Boolean,
      required: true,
    },
    /**
     * 标题组件类型
     * library：标题库
     * component：标题组件
     */
    titleComponentType: {
      type: String,
      default: 'library',
    },
  },
  data() {
    return {
      // 数据弹窗配置
      data_dialog_config: {
        is_show: false,
        is_loading: false,
        title: '',
        active_name: '',
        payload: {},
        map_component_name: {
          convert_id: () => {
            const { channel_interface } = this.init_ops;
            return [CHANNEL_INTERFACE_TYPE.GDT, CHANNEL_INTERFACE_TYPE.BAIDU].includes(channel_interface) ? 'multiple-conversion-event' : 'conversion-event';
          },
          monetization_converts: () => {
            const { channel_interface } = this.init_ops;
            return [CHANNEL_INTERFACE_TYPE.GDT].includes(channel_interface) ? 'multiple-conversion-event' : 'conversion-event';
          },
          purchase_converts: () => {
            const { channel_interface } = this.init_ops;
            return [CHANNEL_INTERFACE_TYPE.GDT].includes(channel_interface) ? 'multiple-conversion-event' : 'conversion-event';
          },
          materials: () => 'material-store',
          channel_package_id: () => 'channel-package',
        },
        getters: {
          getProps: (active_name) => {
            const map_props = {
              convert_id: {
                tableParams: this.getConvertFiltering(),
                getList: this.getConvertList,
              },
              purchase_converts: {
                tableParams: this.getConvertFiltering(),
                getList: this.getConvertList,
              },
              monetization_converts: {
                tableParams: this.getConvertFiltering(),
                getList: this.getConvertList,
              },
              materials: {
                showHorizontalCover: this.getChannelsWithHorizontalCover(),
                materialSources: this.getMaterialSources(),
                channelData: this.getChannelData(),
              },
              channel_package_id: {
                tableParams: this.getChannelPackageFiltering(),
                getList: this.getChannelPackageList,
                pullParams: this.getPullChannelPackageParams(),
                pullApi: pullChannelPackageApi,
              },
            };
            return Object.assign(map_props[active_name] || {});
          },
        },
      },
      // 编辑素材配置
      material_store_config: {
        is_show: false,
        props: {
          title: '编辑素材配置',
        },
        material_sources: [],
        row: null,
        property: '',
      },
      // 表格配置
      dynamic_table_config: {
        header: require('@/views/fusion/investment/intelligence-create/components/main-view/components/preview-table/model/table-key')(this),
        is_show: true,
        loading: false,
        data: [],
        merger: {
          /** 广告 */
          campaign_uuid: {
            rows: [],
            position: '',
          },
        },
        props: {
          class: 'w-full',
          maxHeight: '1200px',
          spanMethod: this.objectSpanMethod,
        },
      },
      // 行编辑表单配置
      form_data_config: {
        // 计划名称
        campaign_name: {},
        // 渠道号
        channel_code: {
          channel_code: {
            label: '渠道号',
            type: 'input',
            rules: [
              {
                required: true,
                message: '请输入渠道号',
                trigger: ['change'],
                validator: notEmptyValidator,
              },
            ],
            props: {
              placeholder: '请输入渠道号',
            },
            value: '',
          },
        },
        // 投放内容
        delivery_content: {
          delivery_content_id: {
            label: '投放内容',
            type: 'select',
            options: [],
            value: '',
            rules: {
              required: true,
              message: '请输入渠道号',
              trigger: ['change'],
            },
          },
        },
        // 广告排期
        schedule_date: getCampaignConfig(['schedule_type', 'delivery_date']),
        // 广告预算
        daily_budget: getCampaignConfig(['daily_budget_type', 'daily_budget']),
        // 广告出价
        price: getCampaignConfig(['price', 'deep_convert_price']),
        // 广告定向
        targeting_id: {
          targeting_id: {
            label: '广告定向',
            type: 'select',
            rules: [
              {
                required: true,
                message: '请选择广告定向',
                trigger: ['change'],
              },
            ],
            props: {
              placeholder: '请选择广告定向',
              valueKey: 'id',
            },
            options: [],
            value: '',
          },
        },
        // 创意名称
        creative_name: getCreativeConfig(['creative_name']),
        // 落地页
        sites: {
          sites: {
            label: '落地页',
            type: 'select',
            rules: [
              {
                required: true,
                message: '请选择落地页',
                trigger: ['change'],
              },
            ],
            props: {
              multiple: true,
              multipleLimit: 1,
              placeholder: '请选择落地页',
              valueKey: 'id',
            },
            options: [],
            value: [],
          },
        },
        // 标题
        titles: {
          titles: {
            label: '标题',
            type: 'select',
            rules: [
              {
                required: true,
                message: '请选择标题',
                trigger: ['change'],
              },
            ],
            props: {
              multiple: true,
              multipleLimit: 1,
              placeholder: '请选择标题',
              valueKey: 'id',
            },
            options: [],
            value: [],
          },
        },
        // 转化事件
        convert_id: getCampaignConfig([
          'convert_id',
          'fusion__optimize_goal',
          'deep_convert_type',
        ]),
        // 创意出价
        creative_price: {},
      },
      // 批量操作配置
      batch_config: {
        is_show: false,
        title: '',
        options: [],
        active_name: '',
        component_name_map: {
          channel_code: 'channel-code',
          sites: 'sites',
        },
        getters: {
          getProps: (active_name) => {
            const map_props = {
              channel_code: {
                tableRows: this.table_selected,
              },
              sites: {
                tableRows: this.table_selected,
                dataSources: this.dataSources,
                formAssignData: this.formAssignData,
                multipleLimit: this.getSitesLimitNum(),
              },
            };
            return Object.assign(map_props[active_name] || {});
          },
        },
      },
      // 表单弹窗编辑
      edit_dialog_config: {
        is_show: false,
        title: '',
        row: null,
        form_data: {},
        // 自定义配置
        custom_config: {},
        component_name_index: {
          parent_key: '',
          children_key: '',
        },
        dynamic_component_map: {
          creative_config: {
            creative_components: {
              [CHANNEL_INTERFACE_TYPE.JRTT]: () => import('@/views/fusion/investment/intelligence-create/components/main-view/components/preview-table/components/edit-dialog/creative-config/creative-components/channel-interface/jrtt/index.vue'),
              [CHANNEL_INTERFACE_TYPE.JRTT_V3]: () => import('@/views/fusion/investment/intelligence-create/components/main-view/components/preview-table/components/edit-dialog/creative-config/creative-components/channel-interface/jrtt/index.vue'),
              [CHANNEL_INTERFACE_TYPE.GDT]: () => import('@/views/fusion/investment/intelligence-create/components/main-view/components/preview-table/components/edit-dialog/creative-config/creative-components/channel-interface/gdt/index.vue'),
            },
          },
        },
        getters: {
          getDynamicComponentName: () => {
            const { component_name_index: { parent_key, children_key }, dynamic_component_map } = this.edit_dialog_config;
            const form = dynamic_component_map[parent_key][children_key];
            const { channel_interface } = this.init_ops;
            return form ? (form[channel_interface] || form['default']) : null;
          },
          getDynamicComponentProps: () => {
            const row = JSON.parse(JSON.stringify(this.edit_dialog_config.row));
            return { row };
          },
        },
      },
      // 表格选择
      table_selected: [],
    };
  },
  computed: {
    /**
     * 渠道控制器配置
     * @returns {Object}
     */
    data_controller() {
      try {
        const form_context = this.local_sharing_data.getFormContext();
        const { dataController } = form_context.config;
        return dataController;
      } catch (error) {
        console.error(error);
        return {};
      }
    },
    /**
     * 渠道初始化配置数据
     * @returns {Object}
     */
    init_ops() {
      try {
        const form_context = this.local_sharing_data.getFormContext();
        const { init_ops } = form_context.config;
        return init_ops;
      } catch (error) {
        console.error(error);
        return {};
      }
    },
    /**
     * 渠道配置
     * @returns {Object}
     */
    channel_config() {
      try {
        const form_context = this.local_sharing_data.getFormContext();
        const { channel_config } = form_context.config;
        return channel_config;
      } catch (error) {
        console.error(error);
        return {};
      }
    },
  },
  watch: {
    dataSources: {
      deep: true,
      immediate: true,
      handler() {
        // 表格数据源更新时刷新表格
        this.processData();
      },
    },
  },
  created() {
    const { channel_interface } = this.init_ops;
    this.batch_config.options = this.getPreviewBatchOptions(channel_interface);
    const { props } = this.form_data_config.sites.sites;
    Object.assign(props, { multipleLimit: this.getSitesLimitNum() });
    Object.assign(this.form_data_config, {
      campaign_name: this.getCampaignNameFormData(),
    });
  },
  methods: {
    /**
     * 获取优化目标
     * @param {Object} params 渠道查询数据
     * @param {number} advertiser_id 广告主ID
     * @returns {Promise<Object[]>}
     */
    async getConvertGoalList(params, advertiser_id) {
      try {
        const { channel_interface } = this.init_ops;
        const res = await getConvertGoalListApi({
          channel_interface,
          advertiser_id,
          ...params,
        });
        const list = (res?.list || []).map(({ id, name, ...rest }) => ({ label: name, value: id, ...rest }));
        return Promise.resolve(list);
      } catch (error) {
        return Promise.reject(new Error(error));
      }
    },
    /**
     * 获取深度转化目标查询参数
     * @param {Object} params 渠道查询数据
     * @param {number} advertiser_id 广告主ID
     * @returns {Object}
     */
    getDeepConvertGoalFiltering(params, advertiser_id) {
      const { channel_interface } = this.init_ops;
      const { payload = {}} = this.data_dialog_config;
      const { row = {}} = payload;
      const {
        advertiser_id: row_advertiser_id,
        campaign: {
          targeting_id,
          site_sets = [],
        } = {},
      } = row;
      const extra_params = {
        [CHANNEL_INTERFACE_TYPE.HUAWEI]: {
          huawei_params: {
            filtering: {
              ...(targeting_id && { targeting_id }),
              ...((site_sets && site_sets.length) ? { site_set_id: site_sets[0] } : {}),
              ...params,
            },
          },
        },
      };
      return {
        channel_interface,
        advertiser_id: advertiser_id || row_advertiser_id,
        [`${channel_interface}_params`]: {
          filtering: {
            ...params,
          },
        },
        ...extra_params[channel_interface],
      };
    },
    /**
     * 获取深度转化目标
     * @param {Object} params 渠道查询数据
     * @param {number} advertiser_id 广告主ID
     * @returns {Promise<Object[]>}
     */
    async getDeepConvertGoal(params, advertiser_id) {
      try {
        this.data_dialog_config.is_loading = true;
        const res = await getDeepConvertGoalApi(this.getDeepConvertGoalFiltering(params, advertiser_id));
        const list = (res?.list || []).map(({ id, name, ...rest }) => ({ label: name, value: id, ...rest }));
        return Promise.resolve(list);
      } catch (error) {
        return Promise.reject(new Error(error));
      } finally {
        this.data_dialog_config.is_loading = true;
      }
    },
    /**
     * 获取转化目标查询参数
     * @returns {Object}
     */
    getConvertFiltering() {
      const { channel_interface } = this.init_ops;
      const { payload } = this.data_dialog_config;
      const { row } = payload;
      const {
        advertiser_id,
        campaign: {
          delivery_content_id,
          delivery_platform_type,
        },
      } = row;

      const strategy = {
        [CHANNEL_INTERFACE_TYPE.GDT]: () => {
          const { campaign: { marketing_sub_goal }} = row;

          return {
            gdt_params: {
              filtering: {
                marketing_sub_goal,
              },
            },
          };
        },
        default: () => {},
      };

      return {
        channel_interface,
        advertiser_id,
        page: 1,
        page_size: 10,
        filtering: {
          ...(delivery_content_id && { delivery_content_id }),
          ...(delivery_platform_type && { delivery_platform_type }),
        },
        ...((strategy[channel_interface] || strategy['default'])()),
      };
    },
    /**
     * 获取转化目标
     * @param {Object} params 查询参数
     * @returns {Promise<Object>}
     */
    getConvertList(params) {
      return new Promise((resolve, reject) => {
        getConvertApi(params)
          .then((res) => {
            res.list.forEach((item) => {
              Object.assign(item, { template_data: JSON.stringify(item) });
            });
            resolve(res);
          })
          .catch(reject);
      });
    },
    /**
     * 获取计划名称表单配置
     * @returns {Object} 符合app-form组件的formData格式数据
     */
    getCampaignNameFormData() {
      const { campaign_config } = this.local_sharing_data.getFormFields();
      const { base_form } = campaign_config.config;
      const { campaign_name } = base_form.config;
      return clone({ campaign_name });
    },
    /**
     * 获取行素材列表数据
     * @returns {Array} 返回素材对象数组或空数组
     */
    getMaterialSources() {
      const { payload } = this.data_dialog_config;
      const { materials } = payload;
      return clone(materials);
    },
    /**
     * 支持横板封面的渠道
     * @returns {boolean}
     */
    getChannelsWithHorizontalCover() {
      const support_channels = [CHANNEL_INTERFACE_TYPE.BAIDU];
      const { channel_interface } = this.init_ops;
      return support_channels.includes(channel_interface);
    },
    /**
     * 获取行渠道信息, 用于选取素材时默认选中游戏
     * @returns {Object}
     */
    getChannelData() {
      const { campaign: { campaign_name_separator }} = this.channel_config;
      const { payload: { row: { campaign: { campaign_name }}}} = this.data_dialog_config;
      const config = {
        game_id: Number(campaign_name.split(campaign_name_separator)[4]),
      };
      return config;
    },
    /**
     * 打开数据弹窗
     * @param {Object} config 配置项
     * @param {string} config.field_key 表单配置项
     * @param {string} config.active_name 表单项名称
     * @param {string} config.title 弹窗标题
     * @param {Object} config.payload 数据,格式：{ row：行数据, cell_value: 单元格数据, form_data: 单元格绑定的表单配置对象，没有可不传 }
     * @returns {void}
     */
    onDataDialog({ form_key, title, payload }) {
      Object.assign(this.data_dialog_config, {
        is_show: true,
        is_loading: false,
        title,
        active_name: form_key,
        payload,
      });
    },
    /**
     * 数据模块确认回调
     * @param {Object} data 确认数据
     * @returns {void}
     */
    async onDataDialogConfirm(data) {
      const { payload, active_name } = this.data_dialog_config;
      const { row, form_data } = payload;
      const { channel_interface } = this.init_ops;
      /** 优化目标枚举值 */
      const convert_goal_enum_val = this.$store.getters[`${channel_interface}EnumVal`].api_fusion_convert_goal;
      const handlers_map = {
        // 转化事件
        convert_id: async() => {
          const strategy = {
            [CHANNEL_INTERFACE_TYPE.HUAWEI]: async() => {
              const { template_data } = data;
              const convert_data = JSON.parse(template_data);
              const { id, convert_goal } = convert_data;
              form_data.convert_id.value = { ...convert_data };
              form_data.fusion__optimize_goal.type = 'label';
              form_data.fusion__optimize_goal.value = convert_goal_enum_val[convert_goal] || '-';
              form_data.fusion__optimize_goal.hidden = !convert_goal;

              /** 获取深度优化目标 */
              const deep_convert_data = await this.getDeepConvertGoal({ convert_id: id });
              form_data.deep_convert_type.type = 'select';
              form_data.deep_convert_type.options = deep_convert_data;
              form_data.deep_convert_type.value = deep_convert_data[0]?.value || '';
              form_data.deep_convert_type.hidden = !deep_convert_data.length;
            },
            [CHANNEL_INTERFACE_TYPE.GDT]: () => {
              const { gdt_params = {}, ...args } = data;
              /** 转化事件 */
              form_data.convert_id.value = {
                ...args,
                is_roi: gdt_params.is_roi,
              };
              const form_context = this.local_sharing_data.getFormContext();
              const { channel_interface } = form_context.config.init_ops;

              /** 优化目标 */
              const convert_goal_enum_val = this.$store.getters[`${channel_interface}EnumVal`].api_fusion_convert_goal;
              form_data.fusion__optimize_goal.type = 'label';
              form_data.fusion__optimize_goal.value = convert_goal_enum_val[data.convert_goal] || '-';
              form_data.fusion__optimize_goal.hidden = !data.convert_goal;

              /** 深度优化目标 */
              const deep_convert_goal_enum_val = this.$store.getters[`${channel_interface}EnumVal`].api_fusion_deep_convert_type;
              form_data.deep_convert_type.type = 'label';
              form_data.deep_convert_type.value = deep_convert_goal_enum_val[data.deep_convert_goal] || '-';
            },
            [CHANNEL_INTERFACE_TYPE.BAIDU]: async() => {
              const { advertiser_id } = row;
              const { template_data } = data;
              const convert_data = JSON.parse(template_data);
              const { id: convert_id } = convert_data;
              const {
                convert_id: convert_id_filed,
                fusion__optimize_goal: fusion__optimize_goal_filed,
                deep_convert_type: deep_convert_type_filed,
              } = form_data;

              // 转化事件
              convert_id_filed.value = { ...convert_data };

              // 优化目标
              fusion__optimize_goal_filed.options = await this.getConvertGoalList({ baidu_params: { filtering: { convert_id }}}, advertiser_id);
              const is_match_optimize_goal = fusion__optimize_goal_filed.options.some(({ value }) => fusion__optimize_goal_filed.value === value);
              if (!is_match_optimize_goal) {
                fusion__optimize_goal_filed.value = '';
                deep_convert_type_filed.value = '';
                deep_convert_type_filed.options = [];
              }
              fusion__optimize_goal_filed.on.change();
            },
          };

          return strategy[channel_interface]();
        },
        // 素材
        materials: () => {
          const { creative: { images = [], videos = [] }} = row;
          images.splice(0);
          videos.splice(0);
          const images_data = data.filter(({ material_type }) => material_type === 1 || material_type === 4).map(({ id, url, name }) => ({ id, urls: url.map(u => u.url), name }));
          const videos_data = data.filter(({ material_type }) => material_type === 2).map(({ id, url, name, width, height }) => ({ id, url: url[0].url, cover: url[0].thumb_url, name, width, height, ...(url[0].horizontal_cover && { horizontal_cover: url[0].horizontal_cover }) }));
          images.push(...images_data);
          videos.push(...videos_data);
        },
        /** 应用渠道包 */
        channel_package_id: () => {
          const { campaign } = row;
          campaign.channel_package_id = data.id;
          campaign.channel_package_name = data.name;

          const strategy = {
            [CHANNEL_INTERFACE_TYPE.BAIDU]: () => {
              Object.assign(campaign, {
                ...(data.baidu_params?.app_name && { delivery_content_name: data.baidu_params.app_name }),
              });
            },
          };
          strategy[channel_interface]?.();
        },
        /** 变现ROI */
        monetization_converts: () => {
          const strategy = {
            [CHANNEL_INTERFACE_TYPE.GDT]: () => {
              form_data.monetization_converts.value.splice(0);
              form_data.monetization_converts.value.push(this.transformConvertsFormValues('monetization', data));
            },
          };
          return strategy[channel_interface]();
        },
        /** 付费ROI */
        purchase_converts: () => {
          const strategy = {
            [CHANNEL_INTERFACE_TYPE.GDT]: () => {
              form_data.purchase_converts.value.splice(0);
              form_data.purchase_converts.value.push(this.transformConvertsFormValues('purchase', data));
            },
          };
          return strategy[channel_interface]();
        },
      };
      await handlers_map[active_name]?.();
      this.onDataDialogCancel();
    },
    /**
     * 数据模块取消回调
     * @returns {void}
     */
    onDataDialogCancel() {
      Object.assign(this.data_dialog_config, {
        is_show: false,
        is_loading: false,
        title: '',
        active_name: '',
      });
    },
    /**
     * 合并行
     * @param {object} data 包含行和列信息的对象
     * @returns {Object} 格式：{ rowspan: 跨越的行数, colspan: 跨越的列数 }
     */
    objectSpanMethod({ rowIndex, columnIndex }) {
      const is_campaign = columnIndex <= 13;
      if (is_campaign) {
        const field = 'campaign_uuid';
        const rowspan = this.dynamic_table_config.merger[field].rows[rowIndex];
        const colspan = rowspan > 0 ? 1 : 0;
        return { rowspan, colspan };
      }
    },
    /**
     * 获取合并行信息
     * @param {object[]} data 表格数据
     * @param {string[]} fields 需要合并的行字段名称
     * @returns {void}
     */
    getMergerSpans(data = this.dynamic_table_config.data, fields = Object.keys(this.dynamic_table_config.merger)) {
      fields.forEach((field) => {
        const target = this.dynamic_table_config.merger[field];
        target.rows.splice(0);
        target.position = '';
        for (let i = 0; i < data.length; i++) {
          if (i === 0) {
            target.rows.push(1);
            target.position = 0;
          } else {
            if (data[i][field] === data[i - 1][field]) {
              target.rows[target.position] += 1;
              target.rows.push(0);
            } else {
              target.rows.push(1);
              target.position = i;
            }
          }
        }
      });
    },
    /**
     * 数据源修改后的逻辑
     * @returns {Promise<void>}
     */
    async processData() {
      this.dynamic_table_config.data = this.dataSources;
      await this.getMergerSpans();
      this.table_selected.splice(0);
      this.$refs?.['preview_table_ref']?.multipleSelection?.length && this.$refs['preview_table_ref'].multipleSelection.splice(0);
      this.$refs?.['preview_table_ref']?.$refs?.table?.clearSelection?.();
      this.refreshTable();
    },
    /**
     * 刷新表格
     * @returns {void}
     */
    refreshTable() {
      setTimeout(() => {
        this.$nextTick(() => {
          this.$refs?.preview_table_ref?.refer();
        });
      }, 0);
    },
    /**
     * 获取渠道详情
     * @param {string[]} channels 渠道号组成的数组
     * @returns {Promise<Array>} 渠道对象数组
     */
    useGetChannelDetails,
    /**
     * 获取配置的数据源 - 广告定向、标题、落地页、素材
     * @param {string} key 数据源键名
     * @returns {Array} 格式
     */
    getAssignList(key) {
      const list = clone(this.formAssignData[key] || []);
      return list.map(item => ({ label: item.name, value: item }));
    },
    /**
     * 获取标题组件类型
     * library: 标题库
     * component: 标题组件
     * @returns {string}
     */
    getTitleComponentType() {
      return this.titleComponentType;
    },
    /**
     * 获取查询应用渠道包查询参数
     * @returns {Object}
     */
    getChannelPackageFiltering() {
      const { payload } = this.data_dialog_config;
      const { row } = payload;
      const form_context = this.local_sharing_data.getFormContext();
      const { dataController } = form_context.config;
      const channel_interface = dataController.getChannelInterfaceEnum();
      const { advertiser_id, campaign: { delivery_content_id }} = row;
      return {
        channel_interface,
        advertiser_id,
        page: 1,
        page_size: 10,
        filtering: {
          delivery_content_id,
        },
      };
    },
    /**
     * 获取同步应用渠道包请求参数
     * @returns {Object}
     */
    getPullChannelPackageParams() {
      const { payload } = this.data_dialog_config;
      const { row } = payload;
      const form_context = this.local_sharing_data.getFormContext();
      const { dataController } = form_context.config;
      const channel_interface = dataController.getChannelInterfaceEnum();
      const { advertiser_id, campaign: { delivery_content_id }} = row;
      return {
        channel_interface,
        advertiser_id,
        filtering: {
          delivery_content_id,
        },
      };
    },
    /**
     * 获取渠道包列表
     * @param {Object} params 查询参数
     * @returns {Promise<Object>}
     */
    getChannelPackageList(params) {
      return new Promise((resolve, reject) => {
        getChannelPackageApi(params)
          .then((res) => {
            res.list.forEach((item) => {
              Object.assign(item, { template_data: JSON.stringify(item) });
            });
            resolve(res);
          })
          .catch(reject);
      });
    },
    /**
     * 是否支持编辑投放内容
     * @returns {boolean}
     */
    supportEditDeliveryContent() {
      const strategy = {
        [CHANNEL_INTERFACE_TYPE.BILIBILI]: () => {
          return true;
        },
        default: () => false,
      };

      const { channel_interface } = this.init_ops;
      return (strategy[channel_interface] || strategy['default'])();
    },
    /**
     * 是否支持编辑应用渠道包
     * @param {Object} row 行数据
     * @returns {boolean}
     */
    supportEditChannelPackage(row) {
      const { campaign } = row;
      const { delivery_platform_type } = campaign;
      const strategy = {
        [CHANNEL_INTERFACE_TYPE.GDT]: () => {
          return true;
        },
        [CHANNEL_INTERFACE_TYPE.JRTT]: () => {
          return true;
        },
        [CHANNEL_INTERFACE_TYPE.JRTT_V3]: () => true,
        [CHANNEL_INTERFACE_TYPE.BAIDU]: () => {
          const is_android = delivery_platform_type === '3';
          return is_android;
        },
        default: () => false,
      };

      const { channel_interface } = this.init_ops;
      return (strategy[channel_interface] || strategy['default'])();
    },
    /**
     * 是否支持编辑转化事件，决定是否渲染转化事件编辑按钮
     * @param {Object} row 行数据
     * @returns {boolean}
     */
    supportEditConvertEvent(row) {
      const { campaign } = row;
      /** 出价方式 */
      const { price_type } = campaign;
      const strategy = {
        [CHANNEL_INTERFACE_TYPE.HUAWEI]: () => {
          return price_type === 'PRICING_OCPC';
        },
        [CHANNEL_INTERFACE_TYPE.GDT]: () => {
          return price_type === 'BID_MODE_OCPM';
        },
        [CHANNEL_INTERFACE_TYPE.BILIBILI]: () => {
          return price_type === '999';
        },
        [CHANNEL_INTERFACE_TYPE.OPPO]: () => {
          return price_type === '5';
        },
        [CHANNEL_INTERFACE_TYPE.VIVO]: () => {
          return price_type === '3' || price_type === '5';
        },
        [CHANNEL_INTERFACE_TYPE.JRTT]: () => {
          return price_type === 'PRICING_OCPM';
        },
        [CHANNEL_INTERFACE_TYPE.JRTT_V3]: () => strategy[CHANNEL_INTERFACE_TYPE.JRTT](),
        [CHANNEL_INTERFACE_TYPE.XIAOMI]: () => {
          return false;
        },
        [CHANNEL_INTERFACE_TYPE.BAIDU]: () => {
          return price_type === '3';
        },
      };
      const { channel_interface } = this.init_ops;
      return strategy[channel_interface]();
    },
    /**
     * 获取转化事件表单项
     * @returns {Object}
     */
    getConvertFields() {
      const { channel_interface } = this.init_ops;
      const strategy = {
        [CHANNEL_INTERFACE_TYPE.BILIBILI]: () => {
          const price_fields = Object.assign({}, this.form_data_config.convert_id, this.getConvertDifferentiatedFields());
          const { fusion__optimize_goal, deep_convert_type, dual_bid_two_stage_optimization } = price_fields;
          return clone({
            fusion__optimize_goal,
            deep_convert_type,
            dual_bid_two_stage_optimization,
          });
        },
        [CHANNEL_INTERFACE_TYPE.OPPO]: () => {
          const price_fields = Object.assign({}, this.form_data_config.convert_id, this.getConvertDifferentiatedFields());
          const { fusion__optimize_goal, deep_convert_type } = price_fields;
          return clone({
            fusion__optimize_goal,
            deep_convert_type,
          });
        },
        [CHANNEL_INTERFACE_TYPE.VIVO]: () => {
          const price_fields = Object.assign({}, this.form_data_config.convert_id, this.getConvertDifferentiatedFields());
          const { fusion__optimize_goal, deep_convert_type, converted_user_filter_days_selection, converted_user_filter_days } = price_fields;
          return clone({
            fusion__optimize_goal,
            deep_convert_type,
            converted_user_filter_days_selection,
            converted_user_filter_days,
          });
        },
        [CHANNEL_INTERFACE_TYPE.GDT]: () => {
          const convert_fields = Object.assign({}, this.form_data_config.convert_id, this.getConvertDifferentiatedFields());
          const { monetization_converts, purchase_converts } = convert_fields;
          return clone({
            ...this.form_data_config.convert_id,
            monetization_converts,
            purchase_converts,
          });
        },
        [CHANNEL_INTERFACE_TYPE.JRTT]: () => {
          const price_fields = Object.assign({}, this.form_data_config.convert_id, this.getConvertDifferentiatedFields());
          const { price_strategy, fusion__optimize_goal, deep_convert_type, deep_bid_type } = price_fields;
          return clone({
            price_strategy,
            fusion__optimize_goal,
            deep_convert_type,
            deep_bid_type,
          });
        },
        [CHANNEL_INTERFACE_TYPE.JRTT_V3]: () => strategy[CHANNEL_INTERFACE_TYPE.JRTT](),
        [CHANNEL_INTERFACE_TYPE.BAIDU]: () => {
          const convert_fields = Object.assign({}, this.form_data_config.convert_id, this.getConvertDifferentiatedFields());
          const { trans_type_attribute, use_roi } = convert_fields;
          return clone({
            ...this.form_data_config.convert_id,
            trans_type_attribute,
            use_roi,
          });
        },
        default: () => {
          return this.form_data_config.convert_id;
        },
      };
      return (strategy[channel_interface] || strategy.default)();
    },
    /**
     * 获取转化事件差异化表单项
     * @returns {Object}
     */
    getConvertDifferentiatedFields() {
      const { campaign_config } = this.local_sharing_data.getFormFields();
      const { budget_and_bid_form } = campaign_config.config;
      const { channel_interface } = this.init_ops;
      const strategy = {
        [CHANNEL_INTERFACE_TYPE.BILIBILI]: () => {
          const { dual_bid_two_stage_optimization } = budget_and_bid_form.config;
          const fields = {
            dual_bid_two_stage_optimization,
          };
          return clone(fields);
        },
        [CHANNEL_INTERFACE_TYPE.VIVO]: () => {
          const { converted_user_filter_days_selection, converted_user_filter_days } = budget_and_bid_form.config;
          const fields = {
            converted_user_filter_days_selection,
            converted_user_filter_days,
          };
          return clone(fields);
        },
        [CHANNEL_INTERFACE_TYPE.GDT]: () => {
          const { monetization_converts, purchase_converts } = budget_and_bid_form.config;
          const fields = {
            monetization_converts,
            purchase_converts,
          };
          return clone(fields);
        },
        [CHANNEL_INTERFACE_TYPE.JRTT]: () => {
          const { price_strategy, deep_bid_type } = budget_and_bid_form.config;
          const fields = {
            price_strategy,
            deep_bid_type,
          };
          return clone(fields);
        },
        [CHANNEL_INTERFACE_TYPE.JRTT_V3]: () => strategy[CHANNEL_INTERFACE_TYPE.JRTT](),
        [CHANNEL_INTERFACE_TYPE.BAIDU]: () => {
          const { trans_type_attribute, use_roi } = budget_and_bid_form.config;
          const fields = {
            trans_type_attribute,
            use_roi,
          };
          return clone(fields);
        },
        default: () => {
          return {};
        },
      };
      return (strategy[channel_interface] || strategy.default)();
    },
    /**
     * 渲染转化事件表单
     * @param {Object} config 配置项
     * @param {Object} config.row 行数据
     * @param {Object} config.form_data 表单配置
     * @param {Object} config.convert_goal_enum_val_key 优化目标枚举key
     * @param {Object} config.deep_type_options_val_key 深度优化目标选项key
     * @param {Object} config.deep_type_enum_val_key 深度优化目标枚举key
     * @param {Object} config.deep_bid_type_enum_val_key 深度优化方式枚举key
     * @returns {void}
     */
    renderConvertEventForm({ row, form_data, convert_goal_enum_val_key, deep_type_options_val_key, deep_type_enum_val_key, deep_bid_type_enum_val_key }) {
      const { campaign, advertiser_id } = row;
      /** 出价方式 */
      const { price_type } = campaign;
      const { channel_interface } = this.init_ops;
      /** 优化目标 */
      const convert_goal_enum_val = this.$store.getters[`${channel_interface}EnumVal`].api_fusion_convert_goal;

      const strategy = {
        [CHANNEL_INTERFACE_TYPE.HUAWEI]: () => {
          const is_ocpc = price_type === 'PRICING_OCPC';
          const {
            /** 转化事件ID */
            convert_id,
            /** 转化名称 */
            convert_name,
            /** 优化目标 */
            convert_goal,
            /** 深度优化目标类型 */
            deep_convert_type,
          } = campaign;
          const {
            convert_id: convert_id_filed,
            fusion__optimize_goal: fusion__optimize_goal_filed,
            deep_convert_type: deep_convert_type_filed,
          } = form_data;

          /**
           * 原始逻辑：!(is_ocpc && convert_id)
           * 由于可能出现分配后不存在转化事件ID的情况，所以当出价方式为ocpc的情况下就显示选择转化目标按钮
           */
          convert_id_filed.hidden = !(is_ocpc);
          fusion__optimize_goal_filed.hidden = !(is_ocpc && convert_id && convert_goal);
          deep_convert_type_filed.hidden = !(is_ocpc && convert_id && deep_convert_type);

          /** 转化事件 */
          convert_id_filed.value = {
            id: convert_id,
            name: convert_name,
            convert_goal,
            deep_convert_goal: deep_convert_type || '',
          };

          /** 优化目标 */
          fusion__optimize_goal_filed.type = 'label';
          fusion__optimize_goal_filed.value = convert_goal_enum_val[convert_goal] || '-';
          deep_convert_type_filed.value = deep_convert_type || '';

          deep_convert_type_filed.options = transformObjectToOptions(row[deep_type_enum_val_key]);
        },
        [CHANNEL_INTERFACE_TYPE.GDT]: () => {
          const is_ocpm = price_type === 'BID_MODE_OCPM';
          const {
            /** 转化事件ID */
            convert_id,
            /** 转化名称 */
            convert_name,
            /**
             * 深度优化出价：出价方式为oCPM时可见(需有深度优化目标配置且优化类型为深度优化行为目标)
             * 深度ROI系数出价：出价方式为oCPM时可见(需有深度优化目标配置且优化类型为深度优化ROI目标)
             */
            is_roi,
            /** 优化目标 */
            convert_goal,
            /** 深度优化目标类型 */
            deep_convert_type,
            /** 场景化投放 */
            smart_delivery_status = 'OFF',
            /** 付费转化 */
            purchase_converts,
            /** 变现转化 */
            monetization_converts,
          } = campaign;

          const {
            convert_id: convert_id_filed,
            fusion__optimize_goal: fusion__optimize_goal_filed,
            deep_convert_type: deep_convert_type_filed,
            monetization_converts: monetization_converts_filed,
            purchase_converts: purchase_converts_filed,
          } = form_data;

          /** 是否开启场景化投放 */
          const is_smart_delivery_status_on = smart_delivery_status === 'ON';

          /**
           * 设置变现ROI目标或付费ROI目标的表单值
           * @param {Object} filed 表单字段
           * @param {string} type 类型：monetization-变现ROI目标，purchase-付费ROI目标
           */
          const setRoiConvertsValue = (filed, type) => {
            filed.value.splice(0);
            const data = this.getConvertsFormValues(type, campaign);
            if (is_smart_delivery_status_on && !!Object.keys(data).length) {
              filed.value.push(data);
            }
          };

          /** 变现ROI目标 */
          const is_has_monetization_converts = is_smart_delivery_status_on && monetization_converts;
          monetization_converts_filed.hidden = !is_has_monetization_converts;
          if (is_has_monetization_converts) {
            setRoiConvertsValue(monetization_converts_filed, 'monetization');
            this.deleteConvertsFormRules(monetization_converts_filed.rules);
          }

          /** 付费ROI目标 */
          const is_has_purchase_converts = is_smart_delivery_status_on && purchase_converts;
          purchase_converts_filed.hidden = !is_has_purchase_converts;
          if (is_has_purchase_converts) {
            setRoiConvertsValue(purchase_converts_filed, 'purchase');
            this.deleteConvertsFormRules(purchase_converts_filed.rules);
          }

          convert_id_filed.hidden = !(is_ocpm && convert_id);
          fusion__optimize_goal_filed.hidden = !(is_ocpm && convert_id && convert_goal);
          deep_convert_type_filed.hidden = !(is_ocpm && convert_id);

          /** 转化事件 */
          convert_id_filed.value = {
            id: convert_id,
            name: convert_name,
            convert_goal,
            deep_convert_goal: deep_convert_type,
            is_roi,
          };

          fusion__optimize_goal_filed.type = 'label';
          fusion__optimize_goal_filed.value = convert_goal_enum_val[convert_goal] || '-';

          /** 深度优化目标 */
          const deep_convert_goal_enum_val = this.$store.getters[`${channel_interface}EnumVal`].api_fusion_deep_convert_type;
          deep_convert_type_filed.type = 'label';
          deep_convert_type_filed.value = deep_convert_goal_enum_val[deep_convert_type] || '-';
        },
        [CHANNEL_INTERFACE_TYPE.BILIBILI]: () => {
          const {
            /** 优化目标 */
            convert_goal,
            /** 深度优化目标类型 */
            deep_convert_type,
            /** 深度优化方式 */
            dual_bid_two_stage_optimization,
            /** 投放平台 */
            delivery_platform_type,
            /** 出价策略 */
            price_strategy,
          } = campaign;
          const {
            fusion__optimize_goal: fusion__optimize_goal_filed,
            deep_convert_type: deep_convert_type_filed,
            dual_bid_two_stage_optimization: dual_bid_two_stage_optimization_filed,
          } = form_data;

          /**
           * 设置深度优化方式可见性
           * 同时满足以下条件时，可见
           * - 出价方式为【oCPM[999]】
           * - 深度优化目标可见
           * - 深度优化目标有值
           * @returns {void}
           */
          const setDualBidTwoStageOptimizationVisible = () => {
            const is_deep_convert_type_visible = !deep_convert_type_filed.hidden;
            dual_bid_two_stage_optimization_filed.hidden = !(is_deep_convert_type_visible && deep_convert_type_filed.value);
          };

          /**
           * 设置深度优化方式选项可选值
           * 同时满足以下条件时，可选【自动优化[1]】
           * - 深度优化目标存在【次日留存[16]】、【应用内付费(首次)[11]】、【表单付费[18]】和【有效线索[13]】之一
           * @returns {void}
           */
          const setDualBidTwoStageOptimizationOptions = () => {
            const is_match = ['16', '11', '18', '13'].includes(deep_convert_type_filed.value);
            dual_bid_two_stage_optimization_filed.options.forEach((opt) => {
              if (opt.value === '1') {
                opt.disabled = !is_match;
              }
            });
            !is_match && (dual_bid_two_stage_optimization_filed.value = '0');
          };

          /** 优化目标 */
          Object.assign(fusion__optimize_goal_filed, {
            label: '优化目标',
            type: 'select',
            hidden: false,
            props: {
              clearable: false,
            },
            on: {
              change: async() => {
                deep_convert_type_filed.options = await this.getDeepConvertGoal({
                  convert_goal: fusion__optimize_goal_filed.value,
                  delivery_platform_type,
                  price_strategy,
                }, advertiser_id);
                const is_match = deep_convert_type_filed.options.some(({ value }) => deep_convert_type_filed.value === value);
                !is_match && (deep_convert_type_filed.value = '');
                deep_convert_type_filed.hidden = !deep_convert_type_filed.options.length;
                setDualBidTwoStageOptimizationVisible();
                setDualBidTwoStageOptimizationOptions();
              },
            },
            options: transformObjectToOptions(this.optionsEnumsVal.convert_goal),
            value: convert_goal,
          });
          const deep_convert_type_options = transformObjectToOptions(row[deep_type_enum_val_key] || this.optionsEnumsVal.deep_convert_type);
          /** 深度优化目标 */
          Object.assign(deep_convert_type_filed, {
            hidden: !deep_convert_type_options?.length,
            on: {
              change: () => {
                setDualBidTwoStageOptimizationVisible();
                setDualBidTwoStageOptimizationOptions();
              },
            },
            options: deep_convert_type_options,
            value: deep_convert_type || '',
          });
          /** 深度优化方式 */
          Object.assign(dual_bid_two_stage_optimization_filed, {
            hidden: !deep_convert_type,
            value: dual_bid_two_stage_optimization || '0',
          });
          const is_match = ['16', '11', '18', '13'].includes(deep_convert_type);
          dual_bid_two_stage_optimization_filed.options.forEach((opt) => {
            if (opt.value === '1') {
              opt.disabled = !is_match;
            }
          });
        },
        [CHANNEL_INTERFACE_TYPE.OPPO]: () => {
          const {
            /** 投放平台 */
            delivery_platform_type,
            /** 广告版位 */
            site_sets,
            /** 优化目标 */
            convert_goal,
            /** 深度优化目标 */
            deep_convert_type,
          } = campaign;
          const {
            fusion__optimize_goal: fusion__optimize_goal_filed,
            deep_convert_type: deep_convert_type_filed,
          } = form_data;

          /** 优化目标 */
          Object.assign(fusion__optimize_goal_filed, {
            label: '优化目标',
            type: 'select',
            hidden: false,
            props: {
              clearable: false,
            },
            on: {
              change: async() => {
                deep_convert_type_filed.options = await this.getDeepConvertGoal({
                  convert_goal: fusion__optimize_goal_filed.value,
                  delivery_platform_type,
                  site_set_id: site_sets[0],
                }, advertiser_id);
                const is_match = deep_convert_type_filed.options.some(({ value }) => deep_convert_type_filed.value === value);
                !is_match && (deep_convert_type_filed.value = '');
                deep_convert_type_filed.hidden = !deep_convert_type_filed.options.length;
              },
            },
            options: transformObjectToOptions(this.optionsEnumsVal.convert_goal),
            value: convert_goal,
          });
          /** 深度优化目标 */
          const deep_convert_type_options = transformObjectToOptions(row[deep_type_enum_val_key] || this.optionsEnumsVal.deep_convert_type);
          Object.assign(deep_convert_type_filed, {
            hidden: !deep_convert_type_options.length,
            options: deep_convert_type_options,
            value: deep_convert_type || '',
          });
        },
        [CHANNEL_INTERFACE_TYPE.VIVO]: () => {
          const {
            /** 投放平台 */
            delivery_platform_type,
            /** 投放内容名称 */
            delivery_content_name,
            /** 计划类型 */
            media_type,
            /** 优化目标 */
            convert_goal,
            /** 深度优化目标 */
            deep_convert_goal,
            /** 过滤已转化用户 */
            converted_user_filter_days,
          } = campaign;
          const {
            fusion__optimize_goal: fusion__optimize_goal_filed,
            deep_convert_type: deep_convert_type_filed,
            converted_user_filter_days_selection: converted_user_filter_days_selection_filed,
            converted_user_filter_days: converted_user_filter_days_filed,
          } = form_data;

          /** 优化目标 */
          Object.assign(fusion__optimize_goal_filed, {
            label: '优化目标',
            type: 'select',
            hidden: false,
            props: {
              clearable: false,
            },
            on: {
              change: async() => {
                converted_user_filter_days_selection_filed.hidden = !['5', '6', '12'].includes(fusion__optimize_goal_filed.value);
                converted_user_filter_days_selection_filed.on.change();

                deep_convert_type_filed.options = await this.getDeepConvertGoal({
                  delivery_platform_type,
                  media_type,
                  package_name: delivery_content_name,
                  convert_goal: fusion__optimize_goal_filed.value,
                }, advertiser_id);
                const is_match = deep_convert_type_filed.options.some(({ value }) => deep_convert_type_filed.value === value);
                !is_match && (deep_convert_type_filed.value = '');
                deep_convert_type_filed.hidden = !deep_convert_type_filed.options.length;
              },
            },
            options: this.optionsVal.convert_goal,
            value: convert_goal,
          });
          /** 深度优化目标 */
          const deep_convert_type_options = row[deep_type_options_val_key] || this.optionsVal.deep_convert_type;
          Object.assign(deep_convert_type_filed, {
            hidden: !deep_convert_type_options.length,
            options: deep_convert_type_options,
            value: deep_convert_goal || '',
          });
          /** 过滤已转化用户 */
          Object.assign(converted_user_filter_days_selection_filed, {
            hidden: !['5', '6', '12'].includes(fusion__optimize_goal_filed.value),
            on: {
              change: () => {
                const is_custom = converted_user_filter_days_selection_filed.value === OPTIONS_TYPE.CUSTOM;
                converted_user_filter_days_filed.hidden = !(is_custom && ['5', '6', '12'].includes(fusion__optimize_goal_filed.value));
              },
            },
          });
          converted_user_filter_days_selection_filed.on.change();
          converted_user_filter_days_filed.value = converted_user_filter_days || '7';
        },
        [CHANNEL_INTERFACE_TYPE.JRTT]: () => {
          const {
            /** 出价策略 */
            price_strategy,
            /** 优化目标 */
            convert_goal,
            /** 深度优化目标 */
            deep_convert_goal,
            /** 深度优化方式 */
            deep_bid_type,
            /** 投放平台 */
            delivery_platform_type,
            /** 投放方式 */
            delivery_mode,
            /** 投放内容ID */
            delivery_content_id,
            /** 包名 */
            package_name,
            /** 营销场景 */
            marketing_goal,
            /** 投放目的 */
            app_promotion_type,
          } = campaign;
          const {
            price_strategy: price_strategy_filed,
            fusion__optimize_goal: fusion__optimize_goal_filed,
            deep_convert_type: deep_convert_type_filed,
            deep_bid_type: deep_bid_type_filed,
          } = form_data;

          /**
           * 设置深度优化方式
           * @param {string} convert_goal 优化目标
           * @param {string} deep_convert_goal 深度优化目标
           * @returns {Promise<void>}
           */
          const setDeepBidTypeData = async(convert_goal, deep_convert_goal) => {
            const is_pay = convert_goal === 'AD_CONVERT_TYPE_PAY';
            if (is_pay || (convert_goal && deep_convert_goal)) {
              deep_bid_type_filed.options = await this.data_controller.getDeepBidTypeList({
                [`${channel_interface}_params`]: {
                  filtering: {
                    delivery_platform_type,
                    delivery_mode,
                    convert_goal,
                    ...(channel_interface === CHANNEL_INTERFACE_TYPE.JRTT_V3
                      ? {
                        marketing_goal,
                        ...(deep_convert_goal && { deep_convert_goal }),
                      }
                      : (deep_convert_goal && { deep_convert_goal })),
                  },
                },
              });
              const is_match_deep_bid_type = deep_bid_type_filed.options.some(({ value }) => deep_bid_type_filed.value === value);
              !is_match_deep_bid_type && (deep_bid_type_filed.value = deep_bid_type_filed.options.length ? deep_bid_type_filed.options[0].value : '');
            } else {
              deep_bid_type_filed.options = [];
              deep_bid_type_filed.value = '';
            }
          };

          Object.assign(price_strategy_filed, {
            props: { disabled: deep_bid_type === 'DEEP_BID_MIN' },
            value: price_strategy,
          });
          /** 优化目标 */
          Object.assign(fusion__optimize_goal_filed, {
            label: '优化目标',
            type: 'select',
            hidden: false,
            props: {
              clearable: false,
            },
            on: {
              change: async() => {
                deep_convert_type_filed.options = await this.getDeepConvertGoal({
                  delivery_platform_type,
                  delivery_mode,
                  delivery_content_id,
                  convert_goal: fusion__optimize_goal_filed.value,
                  ...(channel_interface === CHANNEL_INTERFACE_TYPE.JRTT_V3
                    ? {
                      marketing_goal,
                      ...(app_promotion_type && { app_promotion_type }),
                    }
                    : { package_name }),
                }, advertiser_id);
                const is_match = deep_convert_type_filed.options.some(({ value }) => deep_convert_type_filed.value === value);
                !is_match && (deep_convert_type_filed.value = '');

                await setDeepBidTypeData(fusion__optimize_goal_filed.value, deep_convert_type_filed.value);

                deep_convert_type_filed.hidden = !deep_convert_type_filed.options.length;
                const is_pay = fusion__optimize_goal_filed.value === 'AD_CONVERT_TYPE_PAY';
                deep_bid_type_filed.hidden = !((is_pay || (fusion__optimize_goal_filed.value && deep_convert_type_filed.value)) && deep_bid_type_filed.options.length);
                const is_deep_bid_min = deep_bid_type_filed.value === 'DEEP_BID_MIN';
                price_strategy_filed.props.disabled = is_deep_bid_min;
                is_deep_bid_min && (price_strategy_filed.value = 'CUSTOM');
              },
            },
            options: transformObjectToOptions(this.optionsEnumsVal.convert_goal),
            value: convert_goal,
          });
          /** 深度优化目标 */
          const deep_convert_type_options = transformObjectToOptions(row[deep_type_enum_val_key] || this.optionsEnumsVal.deep_convert_type);
          Object.assign(deep_convert_type_filed, {
            hidden: !deep_convert_type_options.length,
            on: {
              change: async() => {
                await setDeepBidTypeData(fusion__optimize_goal_filed.value, deep_convert_type_filed.value);
                const is_pay = fusion__optimize_goal_filed.value === 'AD_CONVERT_TYPE_PAY';
                deep_bid_type_filed.hidden = !((is_pay || (fusion__optimize_goal_filed.value && deep_convert_type_filed.value)) && deep_bid_type_filed.options.length);
                deep_bid_type_filed.on.change();
              },
            },
            options: deep_convert_type_options,
            value: deep_convert_goal || '',
          });
          /** 深度优化方式 */
          const deep_bid_type_options = transformObjectToOptions(row[deep_bid_type_enum_val_key] || this.optionsEnumsVal.deep_bid_type);
          Object.assign(deep_bid_type_filed, {
            hidden: !deep_bid_type_options.length,
            options: deep_bid_type_options,
            value: deep_bid_type || '',
            on: {
              change: () => {
                const is_deep_bid_min = deep_bid_type_filed.value === 'DEEP_BID_MIN';
                price_strategy_filed.props.disabled = is_deep_bid_min;
                is_deep_bid_min && (price_strategy_filed.value = 'CUSTOM');
              },
            },
          });
        },
        [CHANNEL_INTERFACE_TYPE.JRTT_V3]: () => strategy[CHANNEL_INTERFACE_TYPE.JRTT](),
        [CHANNEL_INTERFACE_TYPE.BAIDU]: () => {
          const {
            /** 转化ID */
            convert_id,
            /** 转化名称 */
            convert_name,
            /** 优化目标 */
            convert_goal,
            /** 深度优化目标 */
            deep_convert_goal,
            /** 付费优化类型 */
            trans_type_attribute,
            /** 使用ROI优化 */
            use_roi,
          } = campaign;
          const {
            convert_id: convert_id_filed,
            fusion__optimize_goal: fusion__optimize_goal_filed,
            deep_convert_type: deep_convert_type_filed,
            trans_type_attribute: trans_type_attribute_filed,
            use_roi: use_roi_filed,
          } = form_data;

          /**
           * 设置付费优化类型可见性
           * 满足以下条件即可设置可见
           * 1. 优化目标为以下值之一
           * - 付费: 26
           * @returns {void}
           */
          const setTransTypeAttributeVisible = () => {
            const is_match = ['26'].includes(fusion__optimize_goal_filed.value);
            trans_type_attribute_filed.hidden = !is_match;
          };

          /**
           * 设置使用ROI优化可见性
           * 满足以下条件即可设置可见
           * 1. 优化目标为以下值之一
           * - 付费: 26
           * @returns {void}
           */
          const setUseRoiVisible = () => {
            const is_match = ['26'].includes(fusion__optimize_goal_filed.value);
            use_roi_filed.hidden = !is_match;
          };

          /** 转化事件 */
          Object.assign(convert_id_filed, {
            hidden: false,
            value: { id: convert_id, name: convert_name },
          });

          /** 优化目标 */
          Object.assign(fusion__optimize_goal_filed, {
            label: '优化目标',
            type: 'select',
            hidden: false,
            props: {
              clearable: false,
            },
            on: {
              change: async() => {
                if (fusion__optimize_goal_filed.value) {
                  const deep_convert_type_options = await this.getDeepConvertGoal({
                    convert_id: convert_id_filed.value.id,
                    convert_goal: fusion__optimize_goal_filed.value,
                  }, advertiser_id);
                  deep_convert_type_filed.options = deep_convert_type_options.filter(({ value }) => value !== fusion__optimize_goal_filed.value);
                  const is_match = deep_convert_type_filed.options.some(({ value }) => deep_convert_type_filed.value === value);
                  !is_match && (deep_convert_type_filed.value = '');
                }

                deep_convert_type_filed.hidden = !deep_convert_type_filed.options.length;
                setTransTypeAttributeVisible();
                setUseRoiVisible();
                use_roi_filed.on.change();
              },
            },
            options: transformObjectToOptions(row[convert_goal_enum_val_key] || this.optionsEnumsVal.convert_goal),
            value: convert_goal,
          });

          /** 深度优化目标 */
          const deep_convert_type_options = transformObjectToOptions(row[deep_type_enum_val_key] || this.optionsEnumsVal.deep_convert_type);
          Object.assign(deep_convert_type_filed, {
            hidden: !deep_convert_type_options.length,
            options: deep_convert_type_options,
            value: deep_convert_goal || '',
          });

          /** 付费优化类型 */
          Object.assign(trans_type_attribute_filed, {
            hidden: !trans_type_attribute,
            value: trans_type_attribute || '1',
          });

          /** 使用ROI优化 */
          Object.assign(use_roi_filed, {
            hidden: !use_roi,
            on: {
              change: () => {
                const is_on = use_roi_filed.value === '1';
                const is_visible = !use_roi_filed.hidden;
                trans_type_attribute_filed.props.disabled = is_visible && is_on;
                (is_visible && is_on) && (trans_type_attribute_filed.value = '1');
              },
            },
            value: use_roi || '0',
          });
          use_roi_filed.on.change();
        },
      };
      return strategy[channel_interface]();
    },
    /**
     * 获取转化事件单元格值
     * @param {Object} payload
     * @param {Object} payload.row 行数据
     * @param {string} payload.convert_goal_enum_val_key 优化目标枚举key
     * @param {string} payload.deep_type_enum_val_key 深度优化目标枚举key
     * @returns {string} 格式：优化目标 - 深度优化目标
     */
    getConvertCellValue({ row, convert_goal_enum_val_key, deep_type_enum_val_key }) {
      const { campaign } = row;
      const { channel_interface } = this.init_ops;
      /** 优化目标 */
      const convert_goal_enum_val = this.$store.getters[`${channel_interface}EnumVal`].api_fusion_convert_goal;
      const {
        price_type,
        convert_id,
        convert_goal,
        deep_convert_type,
      } = campaign;
        /** 校验对象是否存在某个属性 */
      const hasOwnProperty = (target, key) => Object.prototype.hasOwnProperty.call(target, key);
      const strategy = {
        [CHANNEL_INTERFACE_TYPE.HUAWEI]: () => {
          const is_ocpc = price_type === 'PRICING_OCPC';

          const valid_convert_goal = is_ocpc && convert_id && convert_goal;
          const names = [valid_convert_goal ? convert_goal_enum_val[convert_goal] : ''];

          /** 是否存在深度优化目标配置属性 */
          const has_deep_convert_type = hasOwnProperty(campaign, 'deep_convert_type');
          /** 存在深度优化目标配置且值不为空 */
          const valid_deep_convert_type = has_deep_convert_type && deep_convert_type;

          // 初始化深度优化目标枚举
          row[deep_type_enum_val_key] = row[deep_type_enum_val_key] || this.optionsEnumsVal.deep_convert_type;
          /** 深度优化目标枚举 */
          const deep_type_enum_val = row[deep_type_enum_val_key] || {};

          valid_deep_convert_type && names.push(deep_type_enum_val[deep_convert_type] || deep_convert_type);
          return is_ocpc ? names.join('-') : '-';
        },
        [CHANNEL_INTERFACE_TYPE.GDT]: () => {
          const { smart_delivery_status = 'OFF' } = campaign;
          const is_smart_delivery_status_on = smart_delivery_status === 'ON';
          /** 场景化投放开启时固定展示场景化投放 */
          if (is_smart_delivery_status_on) {
            return '场景化投放';
          }
          /** 不存在转化ID */
          if (!convert_id) {
            return '-';
          }
          const form_context = this.local_sharing_data.getFormContext();
          const { channel_interface } = form_context.config.init_ops;
          /** 出价方式是ocpm */
          const is_ocpm = price_type === 'BID_MODE_OCPM';
          const valid_convert_goal = is_ocpm && convert_id && convert_goal;
          const names = [valid_convert_goal ? convert_goal_enum_val[convert_goal] : ''];

          /** 深度优化目标 */
          const deep_convert_goal_enum_val = this.$store.getters[`${channel_interface}EnumVal`].api_fusion_deep_convert_type;
          const deep_convert_type_val = deep_convert_goal_enum_val[deep_convert_type];
          deep_convert_type_val && names.push(deep_convert_type_val);

          return is_ocpm ? names.join('-') : '-';
        },
        [CHANNEL_INTERFACE_TYPE.BILIBILI]: () => {
          const is_ocpm = price_type === '999';

          const names = [this.optionsEnumsVal.convert_goal[convert_goal] || convert_goal];

          /** 初始化深度优化目标枚举 */
          row[deep_type_enum_val_key] = row[deep_type_enum_val_key] || this.optionsEnumsVal.deep_convert_type;
          /** 深度优化目标枚举 */
          const deep_type_enum_val = row[deep_type_enum_val_key] || {};

          /** 是否存在深度优化目标配置属性 */
          const has_deep_convert_type = hasOwnProperty(campaign, 'deep_convert_type');
          /** 存在深度优化目标配置且值不为空 */
          const valid_deep_convert_type = has_deep_convert_type && deep_convert_type;
          valid_deep_convert_type && names.push(deep_type_enum_val[deep_convert_type] || deep_convert_type);

          return is_ocpm ? names.join('-') : '-';
        },
        [CHANNEL_INTERFACE_TYPE.OPPO]: () => {
          const is_ocpx = price_type === '5';

          const names = [this.optionsEnumsVal.convert_goal[convert_goal] || convert_goal];

          /** 初始化深度优化目标枚举 */
          row[deep_type_enum_val_key] = row[deep_type_enum_val_key] || this.optionsEnumsVal.deep_convert_type;
          /** 深度优化目标枚举 */
          const deep_type_enum_val = row[deep_type_enum_val_key] || {};

          /** 存在深度优化目标配置且值不为空 */
          const valid_deep_convert_type = hasOwnProperty(campaign, 'deep_convert_type') && deep_convert_type;
          valid_deep_convert_type && names.push(deep_type_enum_val[deep_convert_type] || deep_convert_type);

          return is_ocpx ? names.join('-') : '-';
        },
        [CHANNEL_INTERFACE_TYPE.VIVO]: () => {
          const { deep_convert_goal } = campaign;
          const is_ocpx = price_type === '3' || price_type === '5';

          const names = [this.optionsEnumsVal.convert_goal[convert_goal] || convert_goal];

          /** 初始化深度优化目标枚举 */
          row[deep_type_enum_val_key] = row[deep_type_enum_val_key] || this.optionsEnumsVal.deep_convert_type;
          /** 深度优化目标枚举 */
          const deep_type_enum_val = row[deep_type_enum_val_key] || {};

          /** 存在深度优化目标配置且值不为空 */
          const valid_deep_convert_type = hasOwnProperty(campaign, 'deep_convert_goal') && deep_convert_goal;
          valid_deep_convert_type && names.push(deep_type_enum_val[deep_convert_goal] || deep_convert_goal);

          return is_ocpx ? names.join('-') : '-';
        },
        [CHANNEL_INTERFACE_TYPE.JRTT]: () => {
          const { deep_convert_goal } = campaign;
          const is_ocpx = price_type === 'PRICING_OCPM';

          const names = [this.optionsEnumsVal.convert_goal[convert_goal] || convert_goal];

          /** 初始化深度优化目标枚举 */
          row[deep_type_enum_val_key] = row[deep_type_enum_val_key] || this.optionsEnumsVal.deep_convert_type;
          /** 深度优化目标枚举 */
          const deep_type_enum_val = row[deep_type_enum_val_key] || {};

          /** 存在深度优化目标配置且值不为空 */
          const valid_deep_convert_type = hasOwnProperty(campaign, 'deep_convert_goal') && deep_convert_goal;
          valid_deep_convert_type && names.push(deep_type_enum_val[deep_convert_goal] || deep_convert_goal);

          return is_ocpx ? names.join('-') : '-';
        },
        [CHANNEL_INTERFACE_TYPE.JRTT_V3]: () => strategy[CHANNEL_INTERFACE_TYPE.JRTT](),
        [CHANNEL_INTERFACE_TYPE.XIAOMI]: () => {
          const { deep_convert_goal } = campaign;

          /** 出价方式是ocpc或ocpd */
          const is_ocpx = price_type === '101' || price_type === '102';

          /** 优化目标枚举值 */
          const convert_goal_val = convert_goal_enum_val[convert_goal] || convert_goal;

          /** 深度优化目标枚举值 */
          const deep_convert_type_enum_val = this.$store.getters[`${channel_interface}EnumVal`].api_fusion_deep_convert_type;
          const deep_convert_type_val = deep_convert_type_enum_val[deep_convert_goal] || deep_convert_goal;

          /** 初始化优化目标枚举值 */
          const names = [convert_goal_val];

          /** 存在深度优化目标配置且值不为空 */
          const valid_deep_convert_type = hasOwnProperty(campaign, 'deep_convert_goal') && deep_convert_goal;
          valid_deep_convert_type && names.push(deep_convert_type_val);

          return is_ocpx ? names.join('-') : '-';
        },
        [CHANNEL_INTERFACE_TYPE.BAIDU]: () => {
          const { deep_convert_goal } = campaign;

          const is_ocpm = price_type === '3';

          const names = [];

          /** 初始化优化目标枚举 */
          row[convert_goal_enum_val_key] = row[convert_goal_enum_val_key] || this.optionsEnumsVal.convert_goal;
          const convert_goal_enum_val = row[convert_goal_enum_val_key] || {};
          const has_convert_goal = hasOwnProperty(campaign, 'convert_goal');
          const valid_convert_goal = has_convert_goal && convert_goal;
          valid_convert_goal && names.push(convert_goal_enum_val[convert_goal] || convert_goal);

          /** 初始化深度优化目标枚举 */
          row[deep_type_enum_val_key] = row[deep_type_enum_val_key] || this.optionsEnumsVal.deep_convert_type;
          const deep_type_enum_val = row[deep_type_enum_val_key] || {};
          const has_deep_convert_goal = hasOwnProperty(campaign, 'deep_convert_goal');
          const valid_deep_convert_goal = has_deep_convert_goal && deep_convert_goal;
          valid_deep_convert_goal && names.push(deep_type_enum_val[deep_convert_goal] || deep_convert_goal);

          return is_ocpm ? names.join('-') : '-';
        },
      };
      return strategy[channel_interface]();
    },
    /**
     * 获取预算类型单元格值
     * @returns {string} 单位元
     */
    getDailyBudgetCellValue({ row }) {
      const { campaign } = row;
      const { daily_budget_type, daily_budget } = campaign;
      const strategy = {
        default: () => {
          /** 指定预算 */
          const isDay = (val) => val === 'BUDGET_MODE_DAY';
          /** 接口返回的预算单位是分，需要转成元来显示 */
          return !isDay(daily_budget_type) ? '不限' : `${this.div(daily_budget, 100)}元/天`;
        },
      };
      const { channel_interface } = this.init_ops;
      return (strategy[channel_interface] || strategy['default'])();
    },
    /**
     * 获取预算类型表单项
     * @returns {Object}
     */
    getDailyBudgetFields() {
      const { channel_interface } = this.init_ops;
      const strategy = {
        [CHANNEL_INTERFACE_TYPE.VIVO]: () => {
          const price_fields = Object.assign({}, this.form_data_config.daily_budget, this.getDailyBudgetDifferentiatedFields());
          const { daily_budget_type, daily_budget, spent_type } = price_fields;
          return clone({
            daily_budget_type,
            daily_budget,
            spent_type,
          });
        },
        default: () => {
          return this.form_data_config.daily_budget;
        },
      };
      return (strategy[channel_interface] || strategy.default)();
    },
    /**
     * 获取预算类型差异化表单项
     * @returns {Object}
     */
    getDailyBudgetDifferentiatedFields() {
      const { channel_interface } = this.init_ops;
      const { campaign_config } = this.local_sharing_data.getFormFields();
      const { budget_and_bid_form } = campaign_config.config;
      const strategy = {
        [CHANNEL_INTERFACE_TYPE.VIVO]: () => {
          const { spent_type } = budget_and_bid_form.config;
          const fields = {
            spent_type,
          };
          return clone(fields);
        },
        default: () => {
          return {};
        },
      };
      return (strategy[channel_interface] || strategy.default)();
    },
    /**
     * 设置预算类型表单项的属性
     */
    setDailyBudgetFiledProps({ row, form_data }) {
      const { channel_interface } = this.init_ops;
      const { campaign } = row;
      const { daily_budget_type, daily_budget, price_strategy } = campaign;
      const {
        daily_budget_type: daily_budget_type_filed,
        daily_budget: daily_budget_filed,
      } = form_data;

      daily_budget_filed.value = isNumber(daily_budget) ? this.div(daily_budget, 100) : daily_budget_filed.props.min;
      daily_budget_filed.hidden = !(daily_budget_type === 'BUDGET_MODE_DAY');

      daily_budget_type_filed.value = daily_budget_type;
      daily_budget_type_filed.on = {
        change: (val) => {
          const is_day = val === 'BUDGET_MODE_DAY';
          daily_budget_filed.hidden = !is_day;
        },
      };

      const strategy = {
        [CHANNEL_INTERFACE_TYPE.HUAWEI]: () => {
          daily_budget_type_filed.props.disabled = false;
          daily_budget_type_filed.value = daily_budget_type;
        },
        [CHANNEL_INTERFACE_TYPE.GDT]: () => {
          /** 出价策略是否是最大转化投放 */
          const is_max = price_strategy === 'BID_SCENE_NORMAL_MAX';
          daily_budget_type_filed.props.disabled = is_max;

          /** 最大转化投放时预算类型只能时指定预算 */
          daily_budget_type_filed.value = is_max ? 'BUDGET_MODE_DAY' : daily_budget_type;
        },
        [CHANNEL_INTERFACE_TYPE.BILIBILI]: () => {
          daily_budget_type_filed.props.disabled = true;
          daily_budget_type_filed.value = daily_budget_type;
        },
        [CHANNEL_INTERFACE_TYPE.OPPO]: () => {
          /** 出价策略是否是最大转化投放 */
          const is_max = price_strategy === '1';
          daily_budget_type_filed.props.disabled = is_max;
          /** 最大转化投放时预算类型只能时指定预算 */
          daily_budget_type_filed.value = is_max ? 'BUDGET_MODE_DAY' : daily_budget_type;
        },
        [CHANNEL_INTERFACE_TYPE.VIVO]: () => {
          const { media_type, spent_type } = campaign;
          const {
            spent_type: spent_type_filed,
          } = form_data;

          spent_type_filed.value = spent_type;

          daily_budget_type_filed.on = {
            change: () => {
              const is_day = daily_budget_type_filed.value === 'BUDGET_MODE_DAY';
              const is_shop = media_type === '0';

              daily_budget_filed.hidden = !is_day;
              // 非商店且指定日预算时，才允许选择匀速投放
              const is_only_speed = !is_shop && is_day;
              spent_type_filed.props.disabled = !is_only_speed;
              !is_only_speed && (spent_type_filed.value = '1');
            },
          };

          daily_budget_type_filed.on.change();
        },
        [CHANNEL_INTERFACE_TYPE.XIAOMI]: () => {
          daily_budget_type_filed.props.disabled = true;
        },
        [CHANNEL_INTERFACE_TYPE.JRTT]: () => {
          const { delivery_mode } = campaign;
          const is_procedural = delivery_mode === 'PROCEDURAL';
          daily_budget_type_filed.props.disabled = is_procedural;
        },
        [CHANNEL_INTERFACE_TYPE.JRTT_V3]: () => strategy[CHANNEL_INTERFACE_TYPE.JRTT](),
        [CHANNEL_INTERFACE_TYPE.BAIDU]: () => {
          /** 出价策略是否是最大转化投放 */
          const is_max = price_strategy === '2';
          daily_budget_type_filed.props.disabled = is_max;
          /** 最大转化投放时预算类型只能时指定预算 */
          daily_budget_type_filed.value = is_max ? 'BUDGET_MODE_DAY' : daily_budget_type;
        },
      };

      strategy[channel_interface]?.();
    },
    /**
     * 确定预算类型表单
     * @param {Object} payload 数据
     * @param {Object} payload.row 当前行数据
     * @param {Object} payload.data 确认后的表单数据
     * @returns {void}
     */
    confirmDailyBudgetForm({ row, data }) {
      const { channel_interface } = this.init_ops;
      const { campaign } = row;
      const { daily_budget_type, daily_budget } = data;

      campaign.daily_budget_type = daily_budget_type;
      if (daily_budget) {
        campaign.daily_budget = this.times(daily_budget, 100);
      } else {
        delete campaign.daily_budget;
      }

      const strategy = {
        [CHANNEL_INTERFACE_TYPE.VIVO]: () => {
          const { spent_type } = data;
          Object.assign(campaign, { spent_type });
        },
      };

      strategy[channel_interface]?.();
    },
    /**
     * 乘法
     * @param {number} multiplicand 被乘数
     * @param {number} multiplier 乘数
     * @returns {number}
     */
    times(multiplicand, multiplier) {
      return calculator.times(multiplicand, multiplier);
    },
    /**
     * 除法
     * @param {number} divisor 除数
     * @param {number} dividend 被除数
     * @returns {number}
     */
    div(divisor, dividend) {
      return calculator.div(divisor, dividend);
    },
    /**
     * 获取广告出价单元格值
     * 格式：出价方式 广告出价{元}/优化目标
     * @returns {string} 单位元
     */
    getPriceCellValue({ row, convert_goal_enum_val_key }) {
      const { campaign } = row;
      const { price_type, price, price_strategy, convert_goal } = campaign;
      const { channel_interface } = this.init_ops;
      /** 出价方式枚举值 */
      const price_type_enum_val = this.$store.getters[`${channel_interface}EnumVal`].api_fusion_price_type;
      /** 优化目标枚举值 */
      const convert_goal_enum_val = this.$store.getters[`${channel_interface}EnumVal`].api_fusion_convert_goal;

      const strategy = {
        [CHANNEL_INTERFACE_TYPE.HUAWEI]: () => {
          /** 出价方式是ocpc */
          const is_ocpc = price_type === 'PRICING_OCPC';

          /** 出价方式 */
          const price_type_unit = price_type_enum_val[price_type] || '';

          /** 广告出价 */
          const price_unit = (price ? `${this.div(price, 100)}元` : '-');

          /** 优化目标 */
          const convert_goal_unit = is_ocpc && convert_goal_enum_val[convert_goal] ? `/${convert_goal_enum_val[convert_goal]}` : '';

          const units = [`${price_type_unit} `, price_unit, convert_goal_unit];

          return units.join('');
        },
        [CHANNEL_INTERFACE_TYPE.GDT]: () => {
          const {
            smart_delivery_status = 'OFF',
            smart_delivery_scene_spec: {
              smart_delivery_goal_spec: {
                mini_game_promotion_spec: {
                  first_day_purchase_roi,
                  first_day_monetization_roi,
                  seven_day_purchase_roi,
                  seven_day_monetization_roi,
                  day30_purchase_roi,
                } = {},
                game_app_activate_roi_spec: {
                  deep_conversion_worth_rate,
                } = {},
              } = {},
            } = {},
          } = campaign;
          /** 出价策略是否是最大转化投放 */
          const is_max = price_strategy === 'BID_SCENE_NORMAL_MAX';
          /** 出价方式是ocpm */
          const is_ocpm = price_type === 'BID_MODE_OCPM';
          /** 出价方式 */
          const price_type_unit = price_type_enum_val[price_type] || '';

          /** 广告出价 */
          const price_unit = (price ? `${this.div(price, 100)}元` : '-');

          /** 优化目标 */
          const convert_goal_unit = is_ocpm && convert_goal_enum_val[convert_goal] ? `/${convert_goal_enum_val[convert_goal]}` : '';

          const units = [`${price_type_unit} `, price_unit, convert_goal_unit];

          /** 场景化投放是否开启 */
          const is_smart_delivery_status_on = smart_delivery_status === 'ON';
          const valid_roi =
            first_day_purchase_roi ||
            first_day_monetization_roi ||
            seven_day_purchase_roi ||
            seven_day_monetization_roi ||
            day30_purchase_roi ||
            deep_conversion_worth_rate;

          /**
           * 出价策略是最大转化投放是显示 出价方式 -
           * 如果场景化投放是开启的，显示 出价方式 ROI效果值
           * 其它情况显示：出价方式 广告出价{元}/优化目标
           */
          return is_smart_delivery_status_on ? `${price_type_unit} ${valid_roi}` : (is_max ? `${price_type_unit} -` : units.join(''));
        },
        [CHANNEL_INTERFACE_TYPE.BILIBILI]: () => {
          const { cpa_bid } = campaign;
          /** 出价方式是ocpm */
          const is_ocpm = price_type === '999';

          /** 出价方式 */
          const price_type_unit = price_type_enum_val[price_type] || '-';

          /** 广告出价 */
          const price_unit = (price ? `${this.div(price, 100)}元` : '-');

          /** 优化目标出价/ROI出价 */
          const cpa_bid_unit = (cpa_bid ? `${this.div(cpa_bid, 100)}` : '-');

          return `${price_type_unit} ${is_ocpm ? cpa_bid_unit : price_unit}`;
        },
        [CHANNEL_INTERFACE_TYPE.OPPO]: () => {
          const { ocpc_price } = campaign;
          /** 出价方式是ocpx */
          const is_ocpx = price_type === '5';

          /** 出价方式 */
          const price_type_unit = this.optionsEnumsVal.price_type[price_type] || '-';

          /** 广告出价 */
          const price_unit = (price ? `${this.div(price, 100)}元` : '-');

          /** 优化目标出价 */
          const cpa_bid_unit = (ocpc_price ? `${this.div(ocpc_price, 100)} ${this.optionsEnumsVal.convert_goal[convert_goal]}/元` : '-');

          return `${price_type_unit} ${is_ocpx ? cpa_bid_unit : price_unit}`;
        },
        [CHANNEL_INTERFACE_TYPE.VIVO]: () => {
          const { convert_goal_price, convert_goal_roi } = campaign;
          /** 出价方式是ocpx */
          const is_ocpx = price_type === '3' || price_type === '5';

          /** 出价方式 */
          const price_type_unit = this.optionsEnumsVal.price_type[price_type] || '-';

          /** 广告出价 */
          const price_unit = (price ? `${this.div(price, 100)}元` : '-');

          /** 优化目标出价 */
          const cpa_bid_unit = (convert_goal_price ? `${this.div(convert_goal_price, 100)} ${this.optionsEnumsVal.convert_goal[convert_goal]}/元` : convert_goal_roi);

          return `${price_type_unit} ${is_ocpx ? cpa_bid_unit : price_unit}`;
        },
        [CHANNEL_INTERFACE_TYPE.JRTT]: () => {
          const { cpa_bid } = campaign;
          /** 出价方式是ocpx */
          const is_ocpx = price_type === 'PRICING_OCPM';

          /** 出价方式 */
          const price_type_unit = this.optionsEnumsVal.price_type[price_type] || '-';

          /** 广告出价 */
          const price_unit = (price ? `${this.div(price, 100)}元` : '-');

          /** 优化目标出价 */
          const cpa_bid_unit = (cpa_bid ? `${this.div(cpa_bid, 100)} ${this.optionsEnumsVal.convert_goal[convert_goal]}/元` : '-');

          return `${price_type_unit} ${is_ocpx ? cpa_bid_unit : price_unit}`;
        },
        [CHANNEL_INTERFACE_TYPE.JRTT_V3]: () => strategy[CHANNEL_INTERFACE_TYPE.JRTT](),
        [CHANNEL_INTERFACE_TYPE.XIAOMI]: () => {
          /**
           * 展示格式如下：
           * - oCPx
           * -- 出价方式+优化目标出价+单位
           * -- 出价方式+优化ROI系数出价
           *
           * - CPC/CPM
           * 出价方式+广告出价+单位
           *
           * 单位格式如下：
           * - oCPx：元/优化目标
           * - CPC/CPM：元
           */
          const { convert_goal_price, ocpx_bid } = campaign;

          /** 获取枚举值 */
          const getEnumValue = (enum_type, key) => this.optionsEnumsVal[enum_type][key] || '';

          /** 金额分转成元 */
          const getDividedValue = (value) => value ? this.div(value, 100) : '';

          /** 出价方式枚举值 */
          const price_type_enum = getEnumValue('price_type', price_type);

          /** 优化目标枚举值 */
          const convert_goal_enum_val = this.$store.getters[`${channel_interface}EnumVal`].api_fusion_convert_goal;
          const convert_goal_val = convert_goal_enum_val[convert_goal] || '';

          /** 广告出价 */
          const price_value = getDividedValue(price);

          /** 优化目标出价 */
          const convert_goal_price_value = getDividedValue(convert_goal_price);

          /** 优化ROI系数出价 */
          const ocpx_bid_value = ocpx_bid || '';

          /** 出价方式是ocpc、ocpd */
          const OCPX_TYPES = ['101', '102'];

          const is_ocpx = OCPX_TYPES.includes(price_type);

          /** 出价方式cpc/cpd */
          if (!is_ocpx) {
            return `${price_type_enum} ${price_value}元`;
          }

          /** 出价方式是ocpc/ocpd并且存在优化目标出价 */
          if (convert_goal_price_value) {
            return `${price_type_enum} ${convert_goal_price_value}元/${convert_goal_val}`;
          }

          /** 出价方式是ocpc/ocpd并且存在优化ROI系数出价 */
          if (ocpx_bid_value) {
            return `${price_type_enum} ${ocpx_bid_value}`;
          }

          /** 默认返回出价方式枚举值 */
          return price_type_enum;
        },
        [CHANNEL_INTERFACE_TYPE.BAIDU]: () => {
          const { ocpc_bid } = campaign;
          /** 出价方式是ocpx */
          const is_ocpx = price_type === '3';

          /** 出价方式 */
          const price_type_unit = this.optionsEnumsVal.price_type[price_type] || '-';

          /** 广告出价 */
          const price_unit = (price ? `${this.div(price, 100)}元` : '-');

          /** 优化目标出价 */
          const convert_goal_enum_val = row[convert_goal_enum_val_key] || this.optionsEnumsVal.convert_goal || {};
          const ocpc_bid_unit = (ocpc_bid ? `${this.div(ocpc_bid, 100)}元/${convert_goal_enum_val[convert_goal]}` : '-');

          return `${price_type_unit} ${is_ocpx ? ocpc_bid_unit : price_unit}`;
        },
      };
      return strategy[channel_interface]();
    },
    /**
     * 获取广告出价表单项
     * @returns {Object}
     */
    getPriceFields() {
      const { channel_interface } = this.init_ops;
      const strategy = {
        [CHANNEL_INTERFACE_TYPE.HUAWEI]: () => {
          const price_fields = Object.assign({}, this.form_data_config.price, this.getPriceDifferentiatedFields());
          const { price, conversion_cost, deep_convert_price } = price_fields;
          return clone({
            price,
            conversion_cost,
            deep_convert_price,
          });
        },
        [CHANNEL_INTERFACE_TYPE.GDT]: () => {
          const price_fields = Object.assign({}, this.form_data_config.price, this.getPriceDifferentiatedFields());
          const { price, deep_convert_price, deep_convert_worth_rate, smart_delivery_scene_spec } = price_fields;
          return clone({
            price,
            deep_convert_price,
            deep_convert_worth_rate,
            smart_delivery_scene_spec,
          });
        },
        [CHANNEL_INTERFACE_TYPE.BILIBILI]: () => {
          const price_fields = Object.assign({}, this.form_data_config.price, this.getPriceDifferentiatedFields());
          const { price, cpa_bid, deep_convert_price } = price_fields;
          return clone({
            price,
            cpa_bid,
            deep_convert_price,
          });
        },
        [CHANNEL_INTERFACE_TYPE.OPPO]: () => {
          const price_fields = Object.assign({}, this.form_data_config.price, this.getPriceDifferentiatedFields());
          const { price, ocpc_price, deep_convert_price, target_roi, ocpx_optimize_switch, ocpx_optimize_type } = price_fields;
          return clone({
            price,
            ocpc_price,
            deep_convert_price,
            target_roi,
            ocpx_optimize_switch,
            ocpx_optimize_type,
          });
        },
        [CHANNEL_INTERFACE_TYPE.VIVO]: () => {
          const price_fields = Object.assign({}, this.form_data_config.price, this.getPriceDifferentiatedFields());
          const { price, convert_goal_price, convert_goal_roi, deep_convert_goal_price, deep_convert_goal_roi } = price_fields;
          return clone({
            price,
            convert_goal_price,
            convert_goal_roi,
            deep_convert_goal_price,
            deep_convert_goal_roi,
          });
        },
        [CHANNEL_INTERFACE_TYPE.JRTT]: () => {
          const price_fields = Object.assign({}, this.form_data_config.price, this.getPriceDifferentiatedFields());
          const { price, cpa_bid, roi_goal } = price_fields;
          return clone({
            price,
            cpa_bid,
            roi_goal,
          });
        },
        [CHANNEL_INTERFACE_TYPE.JRTT_V3]: () => strategy[CHANNEL_INTERFACE_TYPE.JRTT](),
        [CHANNEL_INTERFACE_TYPE.XIAOMI]: () => {
          const price_fields = Object.assign({}, this.form_data_config.price, this.getPriceDifferentiatedFields());
          const { price, convert_goal_price, ocpx_bid, deep_convert_price, deep_ocpx_bid } = price_fields;
          return clone({
            price,
            convert_goal_price,
            ocpx_bid,
            deep_convert_price,
            deep_ocpx_bid,
          });
        },
        [CHANNEL_INTERFACE_TYPE.BAIDU]: () => {
          const price_fields = Object.assign({}, this.form_data_config.price, this.getPriceDifferentiatedFields());
          const { price, ocpc_bid, deep_ocpc_bid, roi_ratio } = price_fields;
          return clone({
            price,
            ocpc_bid,
            deep_ocpc_bid,
            roi_ratio,
          });
        },
      };
      return (strategy[channel_interface])();
    },
    /**
     * 获取广告出价差异化表单项
     * @returns {Object}
     */
    getPriceDifferentiatedFields() {
      const { campaign_config } = this.local_sharing_data.getFormFields();
      const { budget_and_bid_form } = campaign_config.config;
      const { channel_interface } = this.init_ops;
      const strategy = {
        [CHANNEL_INTERFACE_TYPE.HUAWEI]: () => {
          const { conversion_cost } = budget_and_bid_form.config;
          const fields = {
            conversion_cost,
          };
          return clone(fields);
        },
        [CHANNEL_INTERFACE_TYPE.GDT]: () => {
          const { deep_convert_worth_rate, smart_delivery_scene_spec } = budget_and_bid_form.config;
          const fields = {
            deep_convert_worth_rate,
            smart_delivery_scene_spec,
          };
          return clone(fields);
        },
        [CHANNEL_INTERFACE_TYPE.BILIBILI]: () => {
          const { cpa_bid, deep_convert_price } = budget_and_bid_form.config;
          const fields = {
            cpa_bid,
            deep_convert_price,
          };
          return clone(fields);
        },
        [CHANNEL_INTERFACE_TYPE.OPPO]: () => {
          const { ocpc_price, deep_convert_price, target_roi, ocpx_optimize_switch, ocpx_optimize_type } = budget_and_bid_form.config;
          const fields = {
            ocpc_price,
            deep_convert_price,
            target_roi,
            ocpx_optimize_switch,
            ocpx_optimize_type,
          };
          return clone(fields);
        },
        [CHANNEL_INTERFACE_TYPE.VIVO]: () => {
          const { convert_goal_price, convert_goal_roi, deep_convert_goal_price, deep_convert_goal_roi } = budget_and_bid_form.config;
          const fields = {
            convert_goal_price,
            convert_goal_roi,
            deep_convert_goal_price,
            deep_convert_goal_roi,
          };
          return clone(fields);
        },
        [CHANNEL_INTERFACE_TYPE.JRTT]: () => {
          const { cpa_bid, roi_goal } = budget_and_bid_form.config;
          const fields = {
            cpa_bid,
            roi_goal,
          };
          return clone(fields);
        },
        [CHANNEL_INTERFACE_TYPE.JRTT_V3]: () => strategy[CHANNEL_INTERFACE_TYPE.JRTT](),
        [CHANNEL_INTERFACE_TYPE.XIAOMI]: () => {
          const { convert_goal_price, ocpx_bid, deep_ocpx_bid } = budget_and_bid_form.config;
          const fields = {
            convert_goal_price,
            ocpx_bid,
            deep_ocpx_bid,
          };
          return clone(fields);
        },
        [CHANNEL_INTERFACE_TYPE.BAIDU]: () => {
          const { ocpc_bid, deep_ocpc_bid, roi_ratio } = budget_and_bid_form.config;
          const fields = {
            ocpc_bid,
            deep_ocpc_bid,
            roi_ratio,
          };
          return clone(fields);
        },
      };
      return (strategy[channel_interface])();
    },
    /**
     * 是否支持编辑广告出价，决定是否渲染广告出价编辑按钮
     * @param {Object} row 行数据
     * @returns {boolean}
     */
    supportEditPrice(row) {
      const { channel_interface } = this.init_ops;
      const { campaign } = row;
      const { price_strategy } = campaign;
      const strategy = {
        [CHANNEL_INTERFACE_TYPE.GDT]: () => {
          /** 出价策略是否是最大转化投放 */
          const is_max = price_strategy === 'BID_SCENE_NORMAL_MAX';
          return !is_max;
        },
        [CHANNEL_INTERFACE_TYPE.JRTT]: () => {
          const { price, cpa_bid, roi_goal } = campaign;
          const is_has_price = [price, cpa_bid, roi_goal].some(item => isNotNullAndUnDef(item));
          return is_has_price;
        },
        [CHANNEL_INTERFACE_TYPE.JRTT_V3]: () => strategy[CHANNEL_INTERFACE_TYPE.JRTT](),
        [CHANNEL_INTERFACE_TYPE.BAIDU]: () => {
          /** 出价策略是否是最大转化投放 */
          const is_max = price_strategy === '2';
          return !is_max;
        },
        default: () => true,
      };
      return (strategy[channel_interface] || strategy['default'])();
    },
    /**
     * 设置广告出价表单项属性
     * @returns {void}
     */
    setPriceFiledProps({ row, form_data, convert_goal_enum_val_key, deep_type_enum_val_key }) {
      const { channel_interface } = this.init_ops;
      /** 优化目标枚举值 */
      const convert_goal_enum_val = this.$store.getters[`${channel_interface}EnumVal`].api_fusion_convert_goal;
      const { campaign } = row;
      const {
        price_strategy,
        price_type,
        price,
        deep_convert_price,
        deep_convert_type,
      } = campaign;
      const {
        price: price_filed,
        deep_convert_price: deep_convert_price_filed,
      } = form_data;

      /** 校验对象是否存在某个属性 */
      const hasOwnProperty = (target, key) => Object.prototype.hasOwnProperty.call(target, key);
      /** 是否存在广告出价字段 */
      const has_price = hasOwnProperty(campaign, 'price');
      /** 验证广告出价值有效性 */
      const valid_price = has_price && isNumber(price);

      const strategy = {
        [CHANNEL_INTERFACE_TYPE.HUAWEI]: () => {
          const {
            conversion_cost: conversion_cost_filed,
          } = form_data;
          const {
            conversion_cost,
            convert_goal,
          } = campaign;
          /**  出价方式是否是ocpc */
          const is_ocpc = price_type === 'PRICING_OCPC';

          /** 是否存在深度优化目标配置属性 */
          const has_deep_convert_type = hasOwnProperty(campaign, 'deep_convert_type');
          /** 存在深度优化目标配置且值不为空 */
          const valid_deep_convert_type = has_deep_convert_type && deep_convert_type;

          /** 是否存在深度优化出价字段 */
          const has_deep_convert_price = hasOwnProperty(campaign, 'deep_convert_price');
          /** 验证深度优化出价有效性 */
          const valid_deep_convert_price = has_deep_convert_price && isNumber(deep_convert_price);

          /** 是否存在期望转化成本字段 */
          const has_conversion_cost = hasOwnProperty(campaign, 'conversion_cost');
          /** 验证期望转化成本有效性 */
          const valid_conversion_cost = has_conversion_cost && isNumber(conversion_cost);

          /**
           * 广告出价
           * 满足以下条件深度优化出价可见：
           * 存在广告出价字段
           * */
          price_filed.hidden = !(valid_price);

          /**
           * 满足以下条件深度优化出价可见：
           * 存在深度优化出价字段
           * 出价方式是ocpc
           * 存在优化目标
           * 存在深度优化目标
           */
          deep_convert_price_filed.hidden = !(valid_deep_convert_price && is_ocpc && convert_goal && valid_deep_convert_type);

          /**
           * 满足以下条件期望转化成本可见：
           * 存在期望转化成本字段
           * 出价方式是ocpc
           */
          conversion_cost_filed.hidden = !(valid_conversion_cost && is_ocpc);

          price_filed.formItemTips.content = ['元', convert_goal_enum_val[convert_goal] || ''].join('/');

          const deep_type_enum_val = row[deep_type_enum_val_key] || {};

          deep_convert_price_filed.formItemTips.content = ['元', deep_type_enum_val[deep_convert_type] || ''].join('/');

          price_filed.value = valid_price ? this.div(price, 100) : price_filed.props.min;
          deep_convert_price_filed.value = valid_deep_convert_price ? this.div(deep_convert_price, 100) : deep_convert_price_filed.props.min;
          conversion_cost_filed.value = valid_conversion_cost ? this.div(conversion_cost, 100) : conversion_cost_filed.props.min;
        },
        [CHANNEL_INTERFACE_TYPE.GDT]: () => {
          /** 深度优化目标枚举值 */
          const deep_convert_goal_enum_val = this.$store.getters[`${channel_interface}EnumVal`].api_fusion_deep_convert_type;
          /**
           * 深度优化出价：出价方式为oCPM时可见(需有深度优化目标配置且优化类型为深度优化行为目标)
           * 深度ROI系数出价：出价方式为oCPM时可见(需有深度优化目标配置且优化类型为深度优化ROI目标)
           */
          const {
            is_roi,
            /** 优化目标 */
            convert_goal,
            deep_convert_worth_rate,
            smart_delivery_status = 'OFF',
            smart_delivery_scene_spec: {
              smart_delivery_goal,
              smart_delivery_goal_spec: {
                mini_game_promotion_spec = {},
                game_app_activate_roi_spec = {},
              } = {},
            } = {},
          } = campaign;
          const {
            deep_convert_worth_rate: deep_convert_worth_rate_filed,
            smart_delivery_scene_spec: smart_delivery_scene_spec_filed,
          } = form_data;

          /** 出价方式是ocpm */
          const is_ocpm = price_type === 'BID_MODE_OCPM';

          /** 出价策略是否是最大转化投放 */
          const is_max = price_strategy === 'BID_SCENE_NORMAL_MAX';

          /** 是否存在深度优化目标配置属性 */
          const has_deep_convert_type = hasOwnProperty(campaign, 'deep_convert_type');
          /** 存在深度优化目标配置且值不为空 */
          const valid_deep_convert_type = has_deep_convert_type && deep_convert_type;

          /** 是否存在深度优化出价字段 */
          const has_deep_convert_price = hasOwnProperty(campaign, 'deep_convert_price');
          /** 验证深度优化出价有效性 */
          const valid_deep_convert_price = has_deep_convert_price && isNumber(deep_convert_price);

          /** 是否存在深度ROI系数出价字段 */
          const has_deep_convert_worth_rate = hasOwnProperty(campaign, 'deep_convert_worth_rate');
          /** 验证深度ROI系数出价有效性 */
          const valid_deep_convert_worth_rate = has_deep_convert_worth_rate && isNumber(deep_convert_worth_rate);

          /**
           * 广告出价
           * 满足以下条件深度优化出价可见：
           * 存在广告出价字段
           * 出价策略非最大转化投放时
           * */
          price_filed.hidden = !(!is_max && valid_price);

          /**
           * 满足以下条件深度优化出价可见：
           * 存在深度优化出价字段
           * 出价方式是ocpm
           * 存在优化目标
           * 存在深度优化目标
           * 出价策略非最大转化投放时
           * is_roi为false, 即深度优化目标为深度优化行为目标
           */
          deep_convert_price_filed.hidden = !(valid_deep_convert_price && is_ocpm && convert_goal && valid_deep_convert_type && !is_roi && !is_max);

          /**
           * 满足以下条件深度ROI系数出价可见：
           * 存在深度ROI系数出价字段
           * 存在优化目标
           * 存在深度优化目标
           * 出价方式是ocpm
           * 出价策略非最大转化投放时
           * is_roi为true, 即深度优化目标为深度优化行为目标
           */
          deep_convert_worth_rate_filed.hidden = !(valid_deep_convert_worth_rate && is_ocpm && convert_goal && valid_deep_convert_type && is_roi && !is_max);

          price_filed.formItemTips.content = ['元', convert_goal_enum_val[convert_goal] || ''].join('/');
          deep_convert_price_filed.formItemTips.content = ['元', deep_convert_goal_enum_val[deep_convert_type] || ''].join('/');

          price_filed.value = valid_price ? this.div(price, 100) : price_filed.props.min;
          deep_convert_price_filed.value = valid_deep_convert_price ? this.div(deep_convert_price, 100) : deep_convert_price_filed.props.min;
          deep_convert_worth_rate_filed.value = valid_deep_convert_worth_rate ? deep_convert_worth_rate : deep_convert_worth_rate_filed.props.min;

          /** 是否开启场景化投放 */
          const is_smart_delivery_status_on = smart_delivery_status === 'ON';

          this.setFormHiddenProp({ smart_delivery_scene_spec_filed }, !is_smart_delivery_status_on);

          const {
            smart_delivery_goal: smart_delivery_goal_filed,
            smart_delivery_goal_spec: {
              children: {
                mini_game_promotion_spec: {
                  children: {
                    register_cost: register_cost_filed,
                    first_day_purchase_roi: first_day_purchase_roi_filed,
                    first_day_monetization_roi: first_day_monetization_roi_filed,
                    seven_day_purchase_roi: seven_day_purchase_roi_filed,
                    seven_day_monetization_roi: seven_day_monetization_roi_filed,
                    day30_purchase_roi: day30_purchase_roi_filed,
                  },
                },
                game_app_activate_roi_spec: {
                  children: {
                    bid_amount: bid_amount_filed,
                    deep_conversion_worth_rate: deep_conversion_worth_rate_filed,
                  },
                },
              },
            } = {},
          } = smart_delivery_scene_spec_filed.children || {};

          Object.assign(smart_delivery_goal_filed, {
            value: smart_delivery_goal,
            props: {
              disabled: true,
            },
          });

          /** 注册成本 */
          this.handleNumberFiled({ data: mini_game_promotion_spec, filed: register_cost_filed, property: 'register_cost', dividend: 100 });
          /** 首日付费ROI */
          this.handleNumberFiled({ data: mini_game_promotion_spec, filed: first_day_purchase_roi_filed, property: 'first_day_purchase_roi' });
          /** 首日变现ROI */
          this.handleNumberFiled({ data: mini_game_promotion_spec, filed: first_day_monetization_roi_filed, property: 'first_day_monetization_roi' });
          /** 7日付费ROI */
          this.handleNumberFiled({ data: mini_game_promotion_spec, filed: seven_day_purchase_roi_filed, property: 'seven_day_purchase_roi' });
          /** 7日变现ROI */
          this.handleNumberFiled({ data: mini_game_promotion_spec, filed: seven_day_monetization_roi_filed, property: 'seven_day_monetization_roi' });
          /** 30日付费ROI */
          this.handleNumberFiled({ data: mini_game_promotion_spec, filed: day30_purchase_roi_filed, property: 'day30_purchase_roi' });

          /** 激活成本 */
          this.handleNumberFiled({ data: game_app_activate_roi_spec, filed: bid_amount_filed, property: 'bid_amount', dividend: 100 });
          /** 首日付费ROI */
          this.handleNumberFiled({ data: game_app_activate_roi_spec, filed: deep_conversion_worth_rate_filed, property: 'deep_conversion_worth_rate' });
        },
        [CHANNEL_INTERFACE_TYPE.BILIBILI]: () => {
          const {
            cpa_bid: cpa_bid_filed,
          } = form_data;
          const {
            cpa_bid,
          } = campaign;

          /** 出价 */
          price_filed.hidden = !has_price;
          price_filed.value = valid_price ? this.div(price, 100) : price_filed.props.min;

          /** 是否存在优化目标出价/ROI出价字段 */
          const has_cpa_bid = hasOwnProperty(campaign, 'cpa_bid');
          /** 验证优化目标出价/ROI出价有效性 */
          const valid_cpa_bid = has_cpa_bid && isNumber(cpa_bid);
          /** 优化目标出价/ROI出价 */
          cpa_bid_filed.hidden = !has_cpa_bid;
          cpa_bid_filed.value = valid_cpa_bid ? this.div(cpa_bid, 100) : 0.01;

          /** 是否存在深度优化出价/ROI出价字段 */
          const has_deep_convert_price = hasOwnProperty(campaign, 'deep_convert_price');
          /** 验证深度优化出价/ROI出价有效性 */
          const valid_deep_convert_price = has_deep_convert_price && isNumber(deep_convert_price);
          /** 深度优化出价/ROI出价 */
          deep_convert_price_filed.hidden = !has_deep_convert_price;
          deep_convert_price_filed.value = valid_deep_convert_price ? this.div(deep_convert_price, 100) : 0.01;
        },
        [CHANNEL_INTERFACE_TYPE.OPPO]: () => {
          const {
            ocpc_price: ocpc_price_filed,
            target_roi: target_roi_filed,
            ocpx_optimize_switch: ocpx_optimize_switch_filed,
            ocpx_optimize_type: ocpx_optimize_type_filed,
          } = form_data;
          const {
            ocpc_price,
            target_roi,
            ocpx_optimize_switch,
            ocpx_optimize_type,
          } = campaign;

          /** 出价 */
          price_filed.hidden = !has_price;
          price_filed.value = valid_price ? this.div(price, 100) : price_filed.props.min;

          /** 优化目标出价 */
          const has_ocpc_price = hasOwnProperty(campaign, 'ocpc_price');
          const valid_ocpc_price = has_ocpc_price && isNumber(ocpc_price);
          ocpc_price_filed.hidden = !has_ocpc_price;
          ocpc_price_filed.value = valid_ocpc_price ? this.div(ocpc_price, 100) : ocpc_price_filed.props.min;

          /** 深度优化出价 */
          const has_deep_convert_price = hasOwnProperty(campaign, 'deep_convert_price');
          const valid_deep_convert_price = has_deep_convert_price && isNumber(deep_convert_price);
          deep_convert_price_filed.hidden = !has_deep_convert_price;
          deep_convert_price_filed.value = valid_deep_convert_price ? this.div(deep_convert_price, 100) : deep_convert_price_filed.props.min;

          /** 深度ROI系数出价 */
          const has_target_roi = hasOwnProperty(campaign, 'target_roi');
          const valid_target_roi = has_target_roi && isNumber(target_roi);
          target_roi_filed.hidden = !has_target_roi;
          target_roi_filed.value = valid_target_roi ? target_roi : target_roi_filed.props.min;

          /** 自动优化 */
          const has_ocpx_optimize_switch = hasOwnProperty(campaign, 'ocpx_optimize_switch');
          // 广告版位为展示优选 && 深度优化目标有值
          ocpx_optimize_switch_filed.hidden = !(['13'].includes(campaign.site_sets[0]) && has_ocpx_optimize_switch);
          ocpx_optimize_switch_filed.value = has_ocpx_optimize_switch ? ocpx_optimize_switch : '0';
          ocpx_optimize_switch_filed.on = {
            change: () => {
              const is_open = ocpx_optimize_switch_filed.value === '1';
              ocpx_optimize_type_filed.hidden = !is_open;
            },
          };

          /** 自动优化目标 */
          const has_ocpx_optimize_type = hasOwnProperty(campaign, 'ocpx_optimize_type');
          ocpx_optimize_type_filed.hidden = !(has_ocpx_optimize_type && ocpx_optimize_switch_filed.value === '1');
          ocpx_optimize_type_filed.value = has_ocpx_optimize_type ? ocpx_optimize_type : '';
        },
        [CHANNEL_INTERFACE_TYPE.VIVO]: () => {
          const {
            convert_goal_price: convert_goal_price_filed,
            convert_goal_roi: convert_goal_roi_filed,
            deep_convert_goal_price: deep_convert_goal_price_filed,
            deep_convert_goal_roi: deep_convert_goal_roi_filed,
          } = form_data;
          const {
            convert_goal_price,
            convert_goal_roi,
            deep_convert_goal_price,
            deep_convert_goal_roi,
          } = campaign;

          /** 出价 */
          price_filed.hidden = !has_price;
          price_filed.value = valid_price ? this.div(price, 100) : price_filed.props.min;

          /** 优化目标出价 */
          const has_convert_goal_price = hasOwnProperty(campaign, 'convert_goal_price') && isNumber(convert_goal_price);
          const valid_convert_goal_price = has_convert_goal_price && isNumber(convert_goal_price);
          convert_goal_price_filed.hidden = !has_convert_goal_price;
          convert_goal_price_filed.value = valid_convert_goal_price ? this.div(convert_goal_price, 100) : convert_goal_price_filed.props.min;

          /** 优化ROI系数出价 */
          const has_convert_goal_roi = hasOwnProperty(campaign, 'convert_goal_roi');
          const valid_convert_goal_roi = has_convert_goal_roi && isNumber(convert_goal_roi);
          convert_goal_roi_filed.hidden = !has_convert_goal_roi;
          convert_goal_roi_filed.value = valid_convert_goal_roi ? convert_goal_roi : convert_goal_roi_filed.props.min;

          /** 深度优化出价 */
          const has_deep_convert_goal_price = hasOwnProperty(campaign, 'deep_convert_goal_price');
          const valid_deep_convert_goal_price = has_deep_convert_goal_price && isNumber(deep_convert_goal_price);
          deep_convert_goal_price_filed.hidden = !has_deep_convert_goal_price;
          deep_convert_goal_price_filed.value = valid_deep_convert_goal_price ? this.div(deep_convert_goal_price, 100) : deep_convert_goal_price_filed.props.min;

          /** 深度ROI系数出价 */
          const has_deep_convert_goal_roi = hasOwnProperty(campaign, 'deep_convert_goal_roi');
          const valid_deep_convert_goal_roi = has_deep_convert_goal_roi && isNumber(deep_convert_goal_roi);
          deep_convert_goal_roi_filed.hidden = !has_deep_convert_goal_roi;
          deep_convert_goal_roi_filed.value = valid_deep_convert_goal_roi ? deep_convert_goal_roi : deep_convert_goal_roi_filed.props.min;
        },
        [CHANNEL_INTERFACE_TYPE.JRTT]: () => {
          const {
            cpa_bid: cpa_bid_filed,
            roi_goal: roi_goal_filed,
          } = form_data;
          const {
            cpa_bid,
            roi_goal,
          } = campaign;

          /** 出价 */
          price_filed.hidden = !has_price;
          price_filed.value = valid_price ? this.div(price, 100) : price_filed.props.min;

          /** 优化目标出价 */
          const has_convert_goal_price = hasOwnProperty(campaign, 'cpa_bid');
          const valid_convert_goal_price = has_convert_goal_price && isNumber(cpa_bid);
          cpa_bid_filed.hidden = !has_convert_goal_price;
          cpa_bid_filed.value = valid_convert_goal_price ? this.div(cpa_bid, 100) : cpa_bid_filed.props.min;

          /** 深度ROI系数出价 */
          const has_deep_convert_goal_roi = hasOwnProperty(campaign, 'roi_goal');
          const valid_deep_convert_goal_roi = has_deep_convert_goal_roi && isNumber(roi_goal);
          roi_goal_filed.hidden = !has_deep_convert_goal_roi;
          roi_goal_filed.value = valid_deep_convert_goal_roi ? roi_goal : roi_goal_filed.props.min;
        },
        [CHANNEL_INTERFACE_TYPE.JRTT_V3]: () => strategy[CHANNEL_INTERFACE_TYPE.JRTT](),
        [CHANNEL_INTERFACE_TYPE.XIAOMI]: () => {
          const {
            convert_goal_price: convert_goal_price_filed,
            ocpx_bid: ocpx_bid_filed,
            deep_ocpx_bid: deep_ocpx_bid_filed,
          } = form_data;

          const { auto_optimize, convert_goal, deep_convert_goal } = campaign;

          /**
           * 广告出价
           * 满足以下条件广告出价可见：
           * 存在广告出价字段且为数字类型
           * 自动优化为关闭状态
           */
          price_filed.hidden = !(has_price && auto_optimize === 0);
          price_filed.value = valid_price ? this.div(price, 100) : price_filed.props.min;

          /** 优化目标枚举值 */
          const convert_goal_enum_val = this.$store.getters[`${channel_interface}EnumVal`].api_fusion_convert_goal;
          const convert_goal_val = convert_goal_enum_val[convert_goal] || '';

          /** 深度优化目标枚举值 */
          const deep_convert_type_enum_val = this.$store.getters[`${channel_interface}EnumVal`].api_fusion_deep_convert_type;
          const deep_convert_type_val = deep_convert_type_enum_val[deep_convert_goal] || '';

          /** 优化目标出价 */
          this.handleNumberFiled({ data: campaign, filed: convert_goal_price_filed, property: 'convert_goal_price', dividend: 100 });
          convert_goal_price_filed.formItemTips.content = ['元', convert_goal_val].join('/');

          /** 优化ROI系数出价 */
          this.handleNumberFiled({ data: campaign, filed: ocpx_bid_filed, property: 'ocpx_bid' });

          /** 深度优化出价 */
          this.handleNumberFiled({ data: campaign, filed: deep_convert_price_filed, property: 'deep_convert_price', dividend: 100 });
          deep_convert_price_filed.formItemTips.content = ['元', deep_convert_type_val].join('/');

          /** 深度ROI系数出价 */
          this.handleNumberFiled({ data: campaign, filed: deep_ocpx_bid_filed, property: 'deep_ocpx_bid' });
        },
        [CHANNEL_INTERFACE_TYPE.BAIDU]: () => {
          const {
            ocpc_bid: ocpc_bid_filed,
            deep_ocpc_bid: deep_ocpc_bid_filed,
            roi_ratio: roi_ratio_filed,
          } = form_data;

          const { convert_goal, deep_convert_goal } = campaign;

          /** 广告出价 */
          price_filed.hidden = !has_price;
          price_filed.value = valid_price ? this.div(price, 100) : price_filed.props.min;

          /** 优化目标枚举值 */
          const convert_goal_enum_val = row[convert_goal_enum_val_key] || this.optionsEnumsVal.convert_goal || {};
          const convert_goal_val = convert_goal_enum_val[convert_goal] || '';

          /** 深度优化目标枚举值 */
          const deep_convert_type_enum_val = row[deep_type_enum_val_key] || this.optionsEnumsVal.deep_convert_type || {};
          const deep_convert_type_val = deep_convert_type_enum_val[deep_convert_goal] || '';

          /** 优化目标出价 */
          this.handleNumberFiled({ data: campaign, filed: ocpc_bid_filed, property: 'ocpc_bid', dividend: 100 });
          ocpc_bid_filed.formItemTips.content = ['元', convert_goal_val].join('/');

          /** 深度优化出价 */
          this.handleNumberFiled({ data: campaign, filed: deep_ocpc_bid_filed, property: 'deep_ocpc_bid', dividend: 100 });
          deep_ocpc_bid_filed.formItemTips.content = ['元', deep_convert_type_val].join('/');

          /** 深度ROI系数出价 */
          this.handleNumberFiled({ data: campaign, filed: roi_ratio_filed, property: 'roi_ratio' });
        },
      };
      strategy[channel_interface]();
    },
    /**
     * 确定转化事件表单
     * @param {Object} payload 数据
     * @param {Object} payload.row 当前行数据
     * @param {Object} payload.data 确认后的表单数据
     * @param {Object} payload.convert_goal_enum_val_key 优化方式选项key
     * @param {Object} payload.deep_type_options_val_key 深度优化目标选项key
     * @param {Object} payload.deep_bid_type_enum_val_key 深度优化方式选项key
     * @returns {void}
     */
    confirmConvertEventForm({ row, data, convert_goal_enum_val_key, deep_type_options_val_key, deep_bid_type_enum_val_key }) {
      const { channel_interface } = this.init_ops;
      const { campaign, creative } = row;
      const { convert_id, deep_convert_type } = data;

      Object.assign(campaign, {
        /** 转化ID */
        ...(convert_id?.id && { convert_id: convert_id.id }),
        /** 转化名称*/
        ...(convert_id?.name && { convert_name: convert_id.name }),
      });

      if (convert_id?.convert_goal) {
        Object.assign(campaign, {
          /** 优化目标*/
          convert_goal: convert_id.convert_goal,
        });
      } else {
        delete campaign.convert_goal;
      }

      const strategy = {
        [CHANNEL_INTERFACE_TYPE.HUAWEI]: () => {
          if (deep_convert_type) {
            Object.assign(campaign, {
              /** 深度优化目标 */
              deep_convert_type,
              /** 深度优化出价 - 默认值: 0.01 * 100 = 1 */
              deep_convert_price: campaign?.deep_convert_price || 1,
            });
          } else {
            delete campaign.deep_convert_type;
            delete campaign.deep_convert_price;
          }
        },
        [CHANNEL_INTERFACE_TYPE.GDT]: () => {
          Object.assign(campaign, {
            /**
             * 深度优化出价：出价方式为oCPM时可见(需有深度优化目标配置且优化类型为深度优化行为目标)
             * 深度ROI系数出价：出价方式为oCPM时可见(需有深度优化目标配置且优化类型为深度优化ROI目标)
             */
            ...(isNotNullAndUnDef(convert_id?.is_roi) && {
              is_roi: convert_id.is_roi,
            }),
          });

          if (convert_id?.deep_convert_goal) {
            Object.assign(campaign, {
              /** 深度优化目标*/
              deep_convert_type: convert_id.deep_convert_goal,
              /** 深度优化出价 - 出价策略为常规投放时添加，默认值: 0.01 * 100 = 1 */
              ...(campaign.price_strategy === 'BID_SCENE_NORMAL_AVERAGE' && { deep_convert_price: campaign?.deep_convert_price || 1 }),
              /** 深度优化出价 - 出价策略为常规投放时添加，默认值: 0.001 */
              ...(campaign.price_strategy === 'BID_SCENE_NORMAL_AVERAGE' && { deep_convert_worth_rate: campaign?.deep_convert_worth_rate || 0.001 }),
            });
          } else {
            // 无深度优化目标，移除【深度优化目标】、【深度优化出价】和【深度优化ROI系数出价】
            delete campaign.deep_convert_type;
            delete campaign.deep_convert_price;
            delete campaign.deep_convert_worth_rate;
          }
          const { monetization_converts, purchase_converts } = data;
          this.deleteConvertsFormKeys('monetization', campaign);
          this.deleteConvertsFormKeys('purchase', campaign);
          Object.assign(campaign, {
            ...(isArray(monetization_converts) && {
              ...monetization_converts[0],
            }),
            ...(isArray(purchase_converts) && {
              ...purchase_converts[0],
            }),
          });
        },
        [CHANNEL_INTERFACE_TYPE.BILIBILI]: () => {
          const { fusion__optimize_goal, dual_bid_two_stage_optimization } = data;
          Object.assign(campaign, { convert_goal: fusion__optimize_goal });
          if (deep_convert_type) {
            Object.assign(campaign, { deep_convert_type });
          } else {
            delete campaign.deep_convert_type;
          }
          if (dual_bid_two_stage_optimization) {
            Object.assign(campaign, { dual_bid_two_stage_optimization });
          } else {
            delete campaign.dual_bid_two_stage_optimization;
          }
          if (deep_convert_type && (!dual_bid_two_stage_optimization || dual_bid_two_stage_optimization === '0')) {
            Object.assign(campaign, {
              deep_convert_price: campaign.deep_convert_price || 1,
            });
          } else {
            delete campaign.deep_convert_price;
          }
        },
        [CHANNEL_INTERFACE_TYPE.OPPO]: () => {
          const { fusion__optimize_goal } = data;
          // 优化目标
          Object.assign(campaign, { convert_goal: fusion__optimize_goal });
          // 深度优化目标
          if (deep_convert_type) {
            const is_max = campaign.price_strategy === '1';
            Object.assign(campaign, { deep_convert_type });
            // 深度优化目标为游戏付费ROI1、游戏变现ROI1、游戏变现ROI7、变现ROI14、快应用变现ROI1时，显示深度ROI系数出价
            const is_roi = ['23', '41', '42', '46', '47'].includes(deep_convert_type);
            if (!is_roi && !is_max) {
              Object.assign(campaign, { deep_convert_price: campaign.deep_convert_price || 1 });
            } else {
              delete campaign.deep_convert_price;
            }
            if (is_roi && !is_max) {
              Object.assign(campaign, { target_roi: campaign.target_roi || 0.001 });
            } else {
              delete campaign.target_roi;
            }
          } else {
            delete campaign.deep_convert_type;
            delete campaign.deep_convert_price;
            delete campaign.target_roi;
          }
        },
        [CHANNEL_INTERFACE_TYPE.VIVO]: () => {
          const { fusion__optimize_goal, deep_convert_type, converted_user_filter_days } = data;
          // 优化目标
          Object.assign(campaign, { convert_goal: fusion__optimize_goal });
          const is_convert_goal_roi = this.optionsVal.convert_goal.some(({ value, is_roi }) => (fusion__optimize_goal === value) && is_roi);
          if (is_convert_goal_roi) {
            Object.assign(campaign, { convert_goal_roi: campaign.convert_goal_roi || 0.001 });
            delete campaign.convert_goal_price;
          } else {
            Object.assign(campaign, { convert_goal_price: campaign.convert_goal_price || 1 });
            delete campaign.convert_goal_roi;
          }

          // 深度优化目标
          if (deep_convert_type) {
            Object.assign(campaign, { deep_convert_goal: deep_convert_type });

            const is_deep_convert_type_roi = row[deep_type_options_val_key].some(({ value, is_roi }) => (deep_convert_type === value) && is_roi);
            if (is_deep_convert_type_roi) {
              Object.assign(campaign, { deep_convert_goal_roi: campaign.deep_convert_goal_roi || 0.001 });
              delete campaign.deep_convert_goal_price;
            } else {
              Object.assign(campaign, { deep_convert_goal_price: campaign.deep_convert_goal_price || 1 });
              delete campaign.deep_convert_goal_roi;
            }
          } else {
            delete campaign.deep_convert_goal;
            delete campaign.deep_convert_goal_price;
            delete campaign.deep_convert_goal_roi;
          }

          // 过滤已转化用户
          if (converted_user_filter_days) {
            Object.assign(campaign, { converted_user_filter_days });
          } else {
            delete campaign.converted_user_filter_days;
          }
        },
        [CHANNEL_INTERFACE_TYPE.JRTT]: () => {
          row[deep_bid_type_enum_val_key] = transformSchema(this.form_data_config.convert_id.deep_bid_type.options || []);
          const creative_list = this.dataSources.filter(({ campaign_uuid }) => campaign_uuid === row.campaign_uuid);
          const { delivery_mode } = campaign;
          const { price_strategy, fusion__optimize_goal, deep_convert_type, deep_bid_type } = data;
          const is_custom = price_strategy === 'CUSTOM';
          const is_manual = delivery_mode === 'MANUAL';
          // 出价策略
          Object.assign(campaign, { price_strategy });
          // 创意出价 - 优化目标出价
          creative_list.forEach(({ creative }) => {
            if (is_manual && is_custom) {
              Object.assign(creative, { cpa_bid: creative.cpa_bid || 1 });
            } else {
              delete creative.cpa_bid;
            }
          });
          // 优化目标
          Object.assign(campaign, { convert_goal: fusion__optimize_goal });
          // 深度优化目标
          if (deep_convert_type) {
            Object.assign(campaign, { deep_convert_goal: deep_convert_type });
            const is_procedural = delivery_mode === 'PROCEDURAL';
            const is_deep_bid_min = deep_bid_type === 'DEEP_BID_MIN';
            const is_roi_coefficient = deep_bid_type === 'ROI_COEFFICIENT';
            const is_first_and_seven_pay_roi = deep_bid_type === 'FIRST_AND_SEVEN_PAY_ROI';
            const is_has_roi_goal = ['ROI_COEFFICIENT', 'FIRST_AND_SEVEN_PAY_ROI', 'PER_AND_SEVEN_PAY_ROI'].includes(deep_bid_type);
            // 深度ROI系数出价
            if (is_procedural && is_custom && is_has_roi_goal) {
              Object.assign(campaign, { roi_goal: campaign.roi_goal || 0.001 });
            } else {
              delete campaign.roi_goal;
            }
            // 创意出价
            creative_list.forEach(({ creative }) => {
              // 深度优化出价
              if (is_custom && is_deep_bid_min) {
                Object.assign(creative, { deep_cpabid: creative.deep_cpabid || 1 });
              } else {
                delete creative.deep_cpabid;
              }
              // 深度ROI系数出价
              if (is_manual && is_custom && is_roi_coefficient) {
                Object.assign(creative, { roi_goal: creative.roi_goal || 0.001 });
              } else {
                delete creative.roi_goal;
              }
              // 首日ROI系数出价
              if (is_manual && is_custom && is_first_and_seven_pay_roi) {
                Object.assign(creative, { first_roi_goal: creative.first_roi_goal || 0.001 });
              } else {
                delete creative.first_roi_goal;
              }
            });
          } else {
            delete campaign.deep_convert_goal;
            delete campaign.roi_goal;
            // 创意出价
            creative_list.forEach(({ creative }) => {
              delete creative.deep_cpabid;
              delete creative.roi_goal;
              delete creative.first_roi_goal;
            });
          }
          // 深度优化方式
          if (deep_bid_type) {
            Object.assign(campaign, { deep_bid_type });
          } else {
            delete campaign.deep_bid_type;
          }
        },
        [CHANNEL_INTERFACE_TYPE.JRTT_V3]: () => strategy[CHANNEL_INTERFACE_TYPE.JRTT](),
        [CHANNEL_INTERFACE_TYPE.BAIDU]: () => {
          row[convert_goal_enum_val_key] = transformSchema(this.form_data_config.convert_id.fusion__optimize_goal.options || []);

          const { price_strategy, fusion__optimize_goal, deep_convert_type, trans_type_attribute, use_roi } = data;

          const is_on = creative.bid_source === 1;

          // 优化目标
          Object.assign(campaign, { convert_goal: fusion__optimize_goal });

          // 深度优化目标
          if (deep_convert_type) {
            Object.assign(campaign, { deep_convert_goal: deep_convert_type });

            const is_match = ['25', '26'].includes(deep_convert_type);
            if (is_match) {
              Object.assign(campaign, { deep_ocpc_bid: campaign.deep_ocpc_bid || 1 });
              if (is_on) {
                if (!creative.adgroup_bid_params) {
                  Object.assign(creative, { adgroup_bid_params: {}});
                }
                Object.assign(creative.adgroup_bid_params, { deep_ocpc_bid: creative.adgroup_bid_params.deep_ocpc_bid || 1 });
              } else {
                delete creative.adgroup_bid_params?.deep_ocpc_bid;
              }
            } else {
              delete campaign.deep_ocpc_bid;
              delete creative.adgroup_bid_params?.deep_ocpc_bid;
            }
          } else {
            delete campaign.deep_convert_goal;
            delete campaign.deep_ocpc_bid;
            delete creative.adgroup_bid_params?.deep_ocpc_bid;
          }

          // 付费优化类型
          if (trans_type_attribute) {
            Object.assign(campaign, { trans_type_attribute });
          } else {
            delete campaign.trans_type_attribute;
          }

          // 付费优化类型
          if (use_roi) {
            Object.assign(campaign, { use_roi });
            if (use_roi === '1') {
              Object.assign(campaign, { roi_ratio: campaign.roi_ratio || 0.001 });
              if (is_on) {
                if (!creative.adgroup_bid_params) {
                  Object.assign(creative, { adgroup_bid_params: {}});
                }
                Object.assign(creative.adgroup_bid_params, { roi_ratio: creative.adgroup_bid_params.roi_ratio || 0.001 });
              } else {
                delete creative.adgroup_bid_params?.roi_ratio;
              }
            } else {
              delete campaign.roi_ratio;
              delete creative.adgroup_bid_params?.roi_ratio;
            }
          } else {
            delete campaign.use_roi;
            delete campaign.roi_ratio;
            delete creative.adgroup_bid_params?.roi_ratio;
          }

          /**
           * 最大转化投放时，移除以下出价
           * - 优化目标出价
           * - 深度优化出价
           * - 深度ROI系数出价
           * - 创意出价
           */
          const is_max = price_strategy === '2';
          if (is_max) {
            delete campaign.ocpc_bid;
            delete campaign.deep_ocpc_bid;
            delete campaign.roi_ratio;
            delete creative.adgroup_bid_params;
          }
        },
      };
      strategy[channel_interface]();
    },
    /**
     * 确定广告出价表单
     * @param {Object} payload 数据
     * @param {Object} payload.row 当前行数据
     * @param {Object} payload.data 确认后的表单数据
     * @returns {void}
     */
    confirmPriceForm({ row, data }) {
      const { channel_interface } = this.init_ops;
      const { campaign } = row;
      const { price, deep_convert_price } = data;

      if (isNumber(price)) {
        Object.assign(campaign, {
          price: this.times(price, 100),
        });
      } else {
        delete campaign.price;
      }

      if (isNumber(deep_convert_price)) {
        Object.assign(campaign, {
          deep_convert_price: this.times(deep_convert_price, 100),
        });
      } else {
        delete campaign.deep_convert_price;
      }

      const strategy = {
        [CHANNEL_INTERFACE_TYPE.HUAWEI]: () => {
          const { conversion_cost } = data;
          Object.assign(campaign, {
            ...(isNumber(conversion_cost) && { conversion_cost: this.times(conversion_cost, 100) }),
          });
        },
        [CHANNEL_INTERFACE_TYPE.GDT]: () => {
          const { deep_convert_worth_rate, smart_delivery_scene_spec } = data;
          if (isNumber(deep_convert_worth_rate)) {
            Object.assign(campaign, {
              deep_convert_worth_rate,
            });
          } else {
            delete campaign.deep_convert_worth_rate;
          }
          if (smart_delivery_scene_spec) {
            const {
              smart_delivery_goal_spec: {
                mini_game_promotion_spec: {
                  register_cost,
                } = {},
                game_app_activate_roi_spec: {
                  bid_amount,
                } = {},
              } = {},
            } = smart_delivery_scene_spec;
            if (register_cost) {
              smart_delivery_scene_spec.smart_delivery_goal_spec.mini_game_promotion_spec.register_cost = calculator.times(register_cost, 100);
            }
            if (bid_amount) {
              smart_delivery_scene_spec.smart_delivery_goal_spec.game_app_activate_roi_spec.bid_amount = calculator.times(bid_amount, 100);
            }
            Object.keys(smart_delivery_scene_spec.smart_delivery_goal_spec).forEach(key => {
              if (Object.keys(smart_delivery_scene_spec.smart_delivery_goal_spec[key]).length === 0) {
                delete smart_delivery_scene_spec.smart_delivery_goal_spec[key];
              }
            });
            Object.assign(campaign, { smart_delivery_scene_spec });
          } else {
            delete campaign.smart_delivery_scene_spec;
          }
        },
        [CHANNEL_INTERFACE_TYPE.BILIBILI]: () => {
          const { cpa_bid } = data;
          if (isNumber(cpa_bid)) {
            Object.assign(campaign, {
              cpa_bid: this.times(cpa_bid, 100),
            });
          } else {
            delete campaign.cpa_bid;
          }
        },
        [CHANNEL_INTERFACE_TYPE.OPPO]: () => {
          const { ocpc_price, target_roi, ocpx_optimize_switch, ocpx_optimize_type } = data;
          // 优化出价
          if (isNumber(ocpc_price)) {
            Object.assign(campaign, {
              ocpc_price: this.times(ocpc_price, 100),
            });
          } else {
            delete campaign.ocpc_price;
          }
          // 深度ROI系数出价
          if (isNumber(target_roi)) {
            Object.assign(campaign, { target_roi });
          } else {
            delete campaign.target_roi;
          }
          // 自动优化
          if (ocpx_optimize_switch) {
            Object.assign(campaign, { ocpx_optimize_switch });
          } else {
            delete campaign.ocpx_optimize_switch;
          }
          // 自动优化目标
          if (ocpx_optimize_type) {
            Object.assign(campaign, { ocpx_optimize_type });
          } else {
            delete campaign.ocpx_optimize_type;
          }
        },
        [CHANNEL_INTERFACE_TYPE.VIVO]: () => {
          // 优化目标出价
          this.handleNumberProperty({ target: campaign, source: data, property: 'convert_goal_price', multiplier: 100 });
          // 优化ROI系数出价
          this.handleNumberProperty({ target: campaign, source: data, property: 'convert_goal_roi' });
          // 深度优化出价
          this.handleNumberProperty({ target: campaign, source: data, property: 'deep_convert_goal_price', multiplier: 100 });
          // 深度ROI系数出价
          this.handleNumberProperty({ target: campaign, source: data, property: 'deep_convert_goal_roi' });
        },
        [CHANNEL_INTERFACE_TYPE.JRTT]: () => {
          // 优化目标出价
          this.handleNumberProperty({ target: campaign, source: data, property: 'cpa_bid', multiplier: 100 });
          // 深度ROI系数出价
          this.handleNumberProperty({ target: campaign, source: data, property: 'roi_goal' });
        },
        [CHANNEL_INTERFACE_TYPE.JRTT_V3]: () => strategy[CHANNEL_INTERFACE_TYPE.JRTT](),
        [CHANNEL_INTERFACE_TYPE.XIAOMI]: () => {
          /** 优化目标出价 */
          this.handleNumberProperty({ target: campaign, source: data, property: 'convert_goal_price', multiplier: 100 });
          /** 优化ROI系数出价 */
          this.handleNumberProperty({ target: campaign, source: data, property: 'ocpx_bid' });
          /** 深度ROI系数出价 */
          this.handleNumberProperty({ target: campaign, source: data, property: 'deep_ocpx_bid' });
        },
        [CHANNEL_INTERFACE_TYPE.BAIDU]: () => {
          /** 优化目标出价 */
          this.handleNumberProperty({ target: campaign, source: data, property: 'ocpc_bid', multiplier: 100 });
          /** 深度优化出价 */
          this.handleNumberProperty({ target: campaign, source: data, property: 'deep_ocpc_bid', multiplier: 100 });
          /** 深度ROI系数出价 */
          this.handleNumberProperty({ target: campaign, source: data, property: 'roi_ratio' });
        },
      };
      strategy[channel_interface]();
    },
    /**
     * 获取创意出价单元格值
     * @param {Object} payload 数据
     * @param {Object} payload.row 当前行数据
     * @param {string} payload.convert_goal_enum_val_key 优化目标枚举值键名
     * @returns {string} 格式：出价方式 广告出价{元}/优化目标
     * @returns {string} 单位元
     */
    getCreativePriceCellValue({ row, convert_goal_enum_val_key }) {
      const { campaign, creative } = row;
      const { price_type, convert_goal } = campaign;
      const { channel_interface } = this.init_ops;

      const strategy = {
        [CHANNEL_INTERFACE_TYPE.JRTT]: () => {
          const { bid, cpa_bid } = creative;
          /** 出价方式是ocpx */
          const is_ocpx = price_type === 'PRICING_OCPM';

          /** 出价方式 */
          const price_type_unit = this.optionsEnumsVal.price_type[price_type] || '-';

          /** 优化目标出价 */
          const cpa_bid_unit = (cpa_bid ? `${this.div(cpa_bid, 100)} ${this.optionsEnumsVal.convert_goal[convert_goal] || convert_goal}/元` : '-');

          /** 出价 */
          const bid_unit = (bid ? `${this.div(bid, 100)}元` : '-');

          return `${price_type_unit} ${is_ocpx ? cpa_bid_unit : bid_unit}`;
        },
        [CHANNEL_INTERFACE_TYPE.JRTT_V3]: () => strategy[CHANNEL_INTERFACE_TYPE.JRTT](),
        [CHANNEL_INTERFACE_TYPE.BAIDU]: () => {
          const { bid_source, adgroup_bid_params = {}} = creative;
          const { price, ocpc_bid } = adgroup_bid_params;

          /** 出价方式 */
          const price_type_unit = this.optionsEnumsVal.price_type[price_type] || '-';

          /** 广告出价 */
          const price_unit = (price ? `${this.div(price, 100)}元` : '-');

          /** 优化目标出价 */
          const convert_goal_enum_val = row[convert_goal_enum_val_key] || this.optionsEnumsVal.convert_goal || {};
          const ocpc_bid_unit = (ocpc_bid ? `${this.div(ocpc_bid, 100)}元/${convert_goal_enum_val[convert_goal]}` : '-');

          const is_on = bid_source === 1;
          return is_on ? `${price_type_unit} ${price ? price_unit : ocpc_bid_unit}` : '不启用';
        },
        default: () => '-',
      };
      return (strategy[channel_interface] || strategy['default'])();
    },
    /**
     * 是否支持编辑创意出价
     * @param {Object} row 行数据
     * @returns {boolean}
     */
    supportEditCreativePrice(row) {
      const { channel_interface } = this.init_ops;
      const { creative } = row;
      const strategy = {
        [CHANNEL_INTERFACE_TYPE.JRTT]: () => {
          const { budget, bid, cpa_bid, deep_cpabid, roi_goal, first_roi_goal } = creative;
          const is_has_price = [budget, bid, cpa_bid, deep_cpabid, roi_goal, first_roi_goal].some(item => item);
          return is_has_price;
        },
        [CHANNEL_INTERFACE_TYPE.JRTT_V3]: () => strategy[CHANNEL_INTERFACE_TYPE.JRTT](),
        [CHANNEL_INTERFACE_TYPE.BAIDU]: () => true,
        default: () => false,
      };
      return (strategy[channel_interface] || strategy['default'])();
    },
    /**
     * 获取创意出价表单项
     * @returns {Object}
     */
    getCreativePriceFields() {
      const { creative_config } = this.local_sharing_data.getFormFields();
      const { creative_price } = creative_config.config;
      const { channel_interface } = this.init_ops;
      const strategy = {
        [CHANNEL_INTERFACE_TYPE.JRTT]: () => {
          const { budget_selection, budget, bid, cpa_bid, deep_cpabid, roi_goal, first_roi_goal } = creative_price.config;
          return clone({
            budget_selection,
            budget,
            bid,
            cpa_bid,
            deep_cpabid,
            roi_goal,
            first_roi_goal,
          });
        },
        [CHANNEL_INTERFACE_TYPE.JRTT_V3]: () => strategy[CHANNEL_INTERFACE_TYPE.JRTT](),
        [CHANNEL_INTERFACE_TYPE.BAIDU]: () => {
          const { bid_source, price, ocpc_bid, deep_ocpc_bid, roi_ratio } = creative_price.config;
          return clone({
            bid_source,
            price,
            ocpc_bid,
            deep_ocpc_bid,
            roi_ratio,
          });
        },
      };
      return (strategy[channel_interface])();
    },
    /**
     * 设置创意出价表单项属性
     * @returns {void}
     */
    setCreativePriceFiledProps({ row, form_data }) {
      const { channel_interface } = this.init_ops;
      const { campaign, creative } = row;
      /** 校验对象是否存在某个属性 */
      const hasOwnProperty = (target, key) => Object.prototype.hasOwnProperty.call(target, key);

      const strategy = {
        [CHANNEL_INTERFACE_TYPE.JRTT]: () => {
          const {
            budget_selection: budget_selection_filed,
            budget: budget_filed,
            bid: bid_filed,
            cpa_bid: cpa_bid_filed,
            deep_cpabid: deep_cpabid_filed,
            roi_goal: roi_goal_filed,
            first_roi_goal: first_roi_goal_filed,
          } = form_data;
          const {
            budget,
            bid,
            cpa_bid,
            deep_cpabid,
            roi_goal,
            first_roi_goal,
          } = creative;

          /** 创意预算 */
          const has_budget = hasOwnProperty(creative, 'budget');
          const valid_budget = has_budget && isNumber(budget) && budget !== 0;
          budget_selection_filed.hidden = !has_budget;
          budget_filed.hidden = !has_budget;
          budget_filed.value = valid_budget ? this.div(budget, 100) : budget_filed.props.min;

          /** 出价 */
          bid_filed.props.min = campaign.price_type === 'PRICING_CPM' ? 4 : 0.1;
          const has_bid = hasOwnProperty(creative, 'bid');
          const valid_bid = has_bid && isNumber(bid);
          bid_filed.hidden = !has_bid;
          bid_filed.value = valid_bid ? this.div(bid, 100) : bid_filed.props.min;

          /** 优化目标出价 */
          const has_cpa_bid = hasOwnProperty(creative, 'cpa_bid');
          const valid_cpa_bid = has_cpa_bid && isNumber(cpa_bid);
          cpa_bid_filed.hidden = !has_cpa_bid;
          cpa_bid_filed.value = valid_cpa_bid ? this.div(cpa_bid, 100) : cpa_bid_filed.props.min;

          /** 深度优化出价 */
          const has_deep_cpabid = hasOwnProperty(creative, 'deep_cpabid');
          const valid_deep_cpabid = has_deep_cpabid && isNumber(deep_cpabid);
          deep_cpabid_filed.hidden = !has_deep_cpabid;
          deep_cpabid_filed.value = valid_deep_cpabid ? this.div(deep_cpabid, 100) : deep_cpabid_filed.props.min;

          /** 深度ROI系数出价 */
          const has_roi_goal = hasOwnProperty(creative, 'roi_goal');
          const valid_roi_goal = has_roi_goal && isNumber(roi_goal);
          roi_goal_filed.hidden = !has_roi_goal;
          roi_goal_filed.value = valid_roi_goal ? roi_goal : roi_goal_filed.props.min;

          /** 深度ROI系数出价 */
          const has_first_roi_goal = hasOwnProperty(creative, 'first_roi_goal');
          const valid_first_roi_goal = has_first_roi_goal && isNumber(first_roi_goal);
          first_roi_goal_filed.hidden = !has_first_roi_goal;
          first_roi_goal_filed.value = valid_first_roi_goal ? first_roi_goal : first_roi_goal_filed.props.min;
        },
        [CHANNEL_INTERFACE_TYPE.JRTT_V3]: () => strategy[CHANNEL_INTERFACE_TYPE.JRTT](),
        [CHANNEL_INTERFACE_TYPE.BAIDU]: () => {
          const { price_strategy } = campaign;
          const {
            bid_source: bid_source_filed,
            price: price_filed,
            ocpc_bid: ocpc_bid_filed,
            deep_ocpc_bid: deep_ocpc_bid_filed,
            roi_ratio: roi_ratio_filed,
          } = form_data;
          const {
            delivery_mode,
            bid_source,
            adgroup_bid_params = {},
          } = creative;

          const is_max = price_strategy === '2';
          const is_custom = delivery_mode === '0';

          const { price, ocpc_bid, deep_ocpc_bid, roi_ratio } = adgroup_bid_params;

          /** 使用单元出价 */
          Object.assign(bid_source_filed, {
            value: bid_source,
            on: {
              change: () => {
                const is_on = bid_source_filed.value === 1;
                price_filed.hidden = !(is_on && hasOwnProperty(campaign, 'price'));
                ocpc_bid_filed.hidden = !(is_on && hasOwnProperty(campaign, 'ocpc_bid'));
                deep_ocpc_bid_filed.hidden = !(is_on && hasOwnProperty(campaign, 'deep_ocpc_bid'));
                roi_ratio_filed.hidden = !(is_on && hasOwnProperty(campaign, 'roi_ratio'));
              },
            },
          });
          bid_source_filed.props.disabled = (is_custom || is_max);

          /** 广告出价 */
          const has_price = hasOwnProperty(adgroup_bid_params, 'price');
          const valid_price = has_price && isNumber(price);
          price_filed.value = valid_price ? this.div(price, 100) : price_filed.props.min;

          /** 优化目标出价 */
          const has_ocpc_bid = hasOwnProperty(adgroup_bid_params, 'ocpc_bid');
          const valid_ocpc_bid = has_ocpc_bid && isNumber(ocpc_bid);
          ocpc_bid_filed.value = valid_ocpc_bid ? this.div(ocpc_bid, 100) : ocpc_bid_filed.props.min;

          /** 深度优化出价 */
          const has_deep_ocpc_bid = hasOwnProperty(adgroup_bid_params, 'deep_ocpc_bid');
          const valid_deep_ocpc_bid = has_deep_ocpc_bid && isNumber(deep_ocpc_bid);
          deep_ocpc_bid_filed.value = valid_deep_ocpc_bid ? this.div(deep_ocpc_bid, 100) : deep_ocpc_bid_filed.props.min;

          /** 深度ROI系数出价 */
          const has_roi_ratio = hasOwnProperty(adgroup_bid_params, 'roi_ratio');
          const valid_roi_ratio = has_roi_ratio && isNumber(roi_ratio);
          roi_ratio_filed.value = valid_roi_ratio ? roi_ratio : roi_ratio_filed.props.min;

          bid_source_filed.on.change();
        },
      };
      strategy[channel_interface]();
    },
    /**
     * 确定创意出价表单
     * @param {Object} payload 数据
     * @param {Object} payload.row 当前行数据
     * @param {Object} payload.data 确认后的表单数据
     * @returns {void}
     */
    confirmCreativePriceForm({ row, data }) {
      const { channel_interface } = this.init_ops;
      const { creative } = row;

      const strategy = {
        [CHANNEL_INTERFACE_TYPE.JRTT]: () => {
          // 创意预算
          this.handleNumberProperty({ target: creative, source: data, property: 'budget', multiplier: 100 });
          // 出价
          this.handleNumberProperty({ target: creative, source: data, property: 'bid', multiplier: 100 });
          // 优化目标出价
          this.handleNumberProperty({ target: creative, source: data, property: 'cpa_bid', multiplier: 100 });
          // 深度优化出价
          this.handleNumberProperty({ target: creative, source: data, property: 'deep_cpabid', multiplier: 100 });
          // 深度ROI系数出价
          this.handleNumberProperty({ target: creative, source: data, property: 'roi_goal' });
          // 首日ROI系数出价
          this.handleNumberProperty({ target: creative, source: data, property: 'first_roi_goal' });
        },
        [CHANNEL_INTERFACE_TYPE.JRTT_V3]: () => strategy[CHANNEL_INTERFACE_TYPE.JRTT](),
        [CHANNEL_INTERFACE_TYPE.BAIDU]: () => {
          // 使用单元出价
          Object.assign(creative, { bid_source: data.bid_source });
          const is_on = data.bid_source === 1;
          if (is_on) {
            Object.assign(creative, { adgroup_bid_params: {}});
            // 广告出价
            this.handleNumberProperty({ target: creative.adgroup_bid_params, source: data, property: 'price', multiplier: 100 });
            // 优化目标出价
            this.handleNumberProperty({ target: creative.adgroup_bid_params, source: data, property: 'ocpc_bid', multiplier: 100 });
            // 深度优化出价
            this.handleNumberProperty({ target: creative.adgroup_bid_params, source: data, property: 'deep_ocpc_bid', multiplier: 100 });
            // 深度ROI系数出价
            this.handleNumberProperty({ target: creative.adgroup_bid_params, source: data, property: 'roi_ratio' });
          } else {
            delete creative.adgroup_bid_params;
          }
        },
      };
      strategy[channel_interface]();
    },
    /**
     * 获取创意组件单元格值
     * @returns {string}
     */
    getCreativeComponentsCellValue() {
      const { channel_interface } = this.init_ops;

      const strategy = {
        [CHANNEL_INTERFACE_TYPE.JRTT]: () => {
          return '自定义创意组件';
        },
        [CHANNEL_INTERFACE_TYPE.JRTT_V3]: () => strategy[CHANNEL_INTERFACE_TYPE.JRTT](),
        [CHANNEL_INTERFACE_TYPE.GDT]: () => {
          return '自定义创意组件';
        },
        default: () => '-',
      };
      return (strategy[channel_interface] || strategy['default'])();
    },
    /**
     * 是否支持编辑创意组件
     * @param {Object} row 行数据
     * @returns {boolean}
     */
    supportEditCreativeComponents(row) {
      const { channel_interface } = this.init_ops;
      const { creative } = row;
      const strategy = {
        [CHANNEL_INTERFACE_TYPE.JRTT]: () => {
          const { star_task_author_videos } = creative;
          const is_has_components = [star_task_author_videos].some(item => item);
          return is_has_components;
        },
        [CHANNEL_INTERFACE_TYPE.JRTT_V3]: () => strategy[CHANNEL_INTERFACE_TYPE.JRTT](),
        [CHANNEL_INTERFACE_TYPE.GDT]: () => {
          const { wxgame_playable_pages } = creative;
          const is_has_components = [wxgame_playable_pages].some(item => item);
          return is_has_components;
        },
        default: () => false,
      };
      return (strategy[channel_interface] || strategy['default'])();
    },
    /**
     * 获取创意组件表单项
     * @returns {Object}
     */
    getCreativeComponentsFields() {
      const { creative_config } = this.local_sharing_data.getFormFields();
      const { creative_components } = creative_config.config;
      const { channel_interface } = this.init_ops;
      const strategy = {
        [CHANNEL_INTERFACE_TYPE.JRTT]: () => {
          const { star_task_author_videos } = creative_components.config;
          return clone({ star_task_author_videos });
        },
        [CHANNEL_INTERFACE_TYPE.JRTT_V3]: () => strategy[CHANNEL_INTERFACE_TYPE.JRTT](),
        [CHANNEL_INTERFACE_TYPE.GDT]: () => {
          const { wxgame_playable_page } = creative_components.config;
          return clone({ wxgame_playable_page });
        },
      };
      return (strategy[channel_interface])();
    },
    /**
     * 设置创意组件表单项属性
     * @param {Object} data.row 行数据
     * @param {Object} data.form_data 表单配置
     * @param {Object} data.custom_config 自定义配置
     * @returns {void}
     */
    setCreativeComponentsFiledProps({ row, form_data, custom_config }) {
      const { channel_interface } = this.init_ops;
      const { advertiser_id, creative } = row;

      const strategy = {
        [CHANNEL_INTERFACE_TYPE.JRTT]: () => {
          const {
            star_task_author_videos: star_task_author_videos_filed,
          } = form_data;
          const {
            native_settings: {
              aweme_setting_type = 'ALL',
              exclude_aweme_ids = [],
              aweme_ids = [],
            } = {},
            star_task_author_videos,
          } = creative;

          const star_task_author_videos_value = { [advertiser_id]: star_task_author_videos };
          const exclude_aweme_ids_value = exclude_aweme_ids?.length ? { [advertiser_id]: exclude_aweme_ids.map(id => ({ id })) } : {};
          const aweme_ids_value = aweme_ids?.length ? { [advertiser_id]: aweme_ids.map(id => ({ id })) } : {};

          const { star_task_author_videos_filter_config_key } = custom_config;
          const is_has_filter_config = hasOwnProperty(row, star_task_author_videos_filter_config_key) && Object.keys(row[star_task_author_videos_filter_config_key]).length;
          !is_has_filter_config && (row[star_task_author_videos_filter_config_key] = []);
          Object.assign(star_task_author_videos_filed, {
            hidden: false,
            filter_config: {
              'video_publish_time': {
                [advertiser_id]: row[star_task_author_videos_filter_config_key],
              },
            },
            filter_config_backup: {},
            api_params: {
              aweme_setting_type,
              exclude_aweme_ids: exclude_aweme_ids_value,
              aweme_ids: aweme_ids_value,
            },
            assignSelection: JSON.parse(JSON.stringify(star_task_author_videos_value)),
            value: JSON.parse(JSON.stringify(star_task_author_videos_value)),
            rules: { required: true, message: '请选择达人投稿视频', trigger: ['change'] },
          });
        },
        [CHANNEL_INTERFACE_TYPE.JRTT_V3]: () => strategy[CHANNEL_INTERFACE_TYPE.JRTT](),
        [CHANNEL_INTERFACE_TYPE.GDT]: () => {
          const {
            wxgame_playable_page: wxgame_playable_page_filed,
          } = form_data;
          const {
            delivery_mode,
            creative_template_id,
            wxgame_playable_pages,
          } = creative;

          const {
            wxgame_playable_page_switch: wxgame_playable_page_switch_filed,
            wxgame_playable_page_path: wxgame_playable_page_path_filed,
            wxgame_playable_page_end_cover_img: wxgame_playable_page_end_cover_img_filed,
            wxgame_playable_page_end_desc: wxgame_playable_page_end_desc_filed,
            wxgame_playable_page_trigger_types: wxgame_playable_page_trigger_types_filed,
            wxgame_playable_page_trigger_text: wxgame_playable_page_trigger_text_filed,
            wxgame_playable_page_card_link_description: wxgame_playable_page_card_link_description_filed,
            wxgame_playable_page_card_link_image: wxgame_playable_page_card_link_image_filed,
          } = wxgame_playable_page_filed.children;

          const is_customize = delivery_mode === 'DELIVERY_MODE_CUSTOMIZE';
          const is_component = delivery_mode === 'DELIVERY_MODE_COMPONENT';
          const is_match = [910].includes(creative_template_id);

          /**
           * 小游戏试玩页选项
           * 满足以下条件时，小游戏试玩页选项为【开启[true]】且不可切换
           * - 投放模式为【自定义创意[DELIVERY_MODE_CUSTOMIZE]】
           * - 创意形式包含
           *   - 激励浏览广告[910]
           */
          wxgame_playable_page_switch_filed.props.disabled = is_customize && is_match;
          Object.assign(wxgame_playable_page_switch_filed, {
            value: wxgame_playable_pages.wxgame_playable_page_switch,
            on: {
              change: () => {
                const is_custom = wxgame_playable_page_switch_filed.value;

                wxgame_playable_page_path_filed.hidden = !is_custom;
                wxgame_playable_page_end_cover_img_filed.hidden = !is_custom;
                wxgame_playable_page_end_desc_filed.hidden = !is_custom;
                /**
                 * 满足以下条件，试玩页触发类型可见
                 * - 小游戏试玩页为【开启[true]】
                 * - 投放模式为【组件化创意[DELIVERY_MODE_COMPONENT]】 || （投放模式为【自定义创意[DELIVERY_MODE_CUSTOMIZE]】 && 创意形式不为【激励浏览广告[910]】）
                 */
                wxgame_playable_page_trigger_types_filed.hidden = !(is_custom && (is_component || (!is_component && !is_match)));
                wxgame_playable_page_trigger_types_filed.on.change();
                /**
                 * 满足以下条件，试玩页触发文案可见
                 * - 小游戏试玩页为【开启[true]】
                 * - 投放模式为【组件化创意[DELIVERY_MODE_COMPONENT]】 || （投放模式为【自定义创意[DELIVERY_MODE_CUSTOMIZE]】 && 创意形式不为【激励浏览广告[910]】）
                 */
                wxgame_playable_page_trigger_text_filed.hidden = !(is_custom && (is_component || (!is_component && !is_match)));
              },
            },
          });

          // 试玩页
          const { wxgame_playable_page_path_key } = custom_config;
          const wxgame_playable_page_path_value = {
            [advertiser_id]: [{
              url: wxgame_playable_pages.wxgame_playable_page_path,
            }],
          };
          Object.assign(wxgame_playable_page_path_filed, {
            assignSelection: {},
            value: row[wxgame_playable_page_path_key] || (wxgame_playable_pages.wxgame_playable_page_path ? wxgame_playable_page_path_value : {}),
          });

          // 试玩结束封面图
          Object.assign(wxgame_playable_page_end_cover_img_filed, {
            value: wxgame_playable_pages.wxgame_playable_page_end_cover_img || '',
          });

          // 试玩结束文案
          Object.assign(wxgame_playable_page_end_desc_filed, {
            value: wxgame_playable_pages.wxgame_playable_page_end_desc || '',
          });

          // 试玩页触发类型
          Object.assign(wxgame_playable_page_trigger_types_filed, {
            value: wxgame_playable_pages.wxgame_playable_page_trigger_types || ['WXGAME_PLAYABLE_PAGE_TRIGGER_TYPE_CARD_LINK'],
            on: {
              change: () => {
                const is_visible = !wxgame_playable_page_trigger_types_filed.hidden;
                const is_match = wxgame_playable_page_trigger_types_filed.value.includes('WXGAME_PLAYABLE_PAGE_TRIGGER_TYPE_CARD_LINK');

                wxgame_playable_page_card_link_description_filed.hidden = !(is_visible && is_match);
                wxgame_playable_page_card_link_image_filed.hidden = !(is_visible && is_match);
              },
            },
          });

          // 试玩页触发文案
          Object.assign(wxgame_playable_page_trigger_text_filed, {
            value: wxgame_playable_pages.wxgame_playable_page_trigger_text || '立即试玩',
          });

          // 试玩页图文链接文案
          Object.assign(wxgame_playable_page_card_link_description_filed, {
            value: wxgame_playable_pages.wxgame_playable_page_card_link_description || '',
          });

          // 试玩页图文链接图片
          Object.assign(wxgame_playable_page_card_link_image_filed, {
            value: { url: wxgame_playable_pages.wxgame_playable_page_card_link_image || '' },
          });

          wxgame_playable_page_switch_filed.on.change();
        },
      };
      strategy[channel_interface]();
    },
    /**
     * 打开表单编辑弹窗
     * @param {Object} data.row 当前行数据
     * @param {Object} data.parent_key 父键
     * @param {Object} data.children_key 子键
     * @param {Object} data.custom_config 自定义配置
     * @returns {void}
     */
    openEditDialog({ row, parent_key, children_key, custom_config }) {
      const strategy = {
        'creative_config.creative_components': '创意组件配置',
        default: '配置',
      };
      Object.assign(this.edit_dialog_config, {
        title: strategy[`${parent_key}.${children_key}`] || strategy['default'],
        row,
        component_name_index: { parent_key, children_key },
        is_show: true,
        custom_config,
      });
    },
    /**
     * 确定表单编辑弹窗
     * @param {Object} data 确认后的表单数据
     * @returns {void}
     */
    confirmEditDialog(data) {
      const { channel_interface } = this.init_ops;
      const { row, component_name_index: { parent_key, children_key }} = this.edit_dialog_config;

      const strategy = {
        [`creative_config.creative_components.${CHANNEL_INTERFACE_TYPE.JRTT}`]: () => {
          const { advertiser_id, creative } = row;
          const { star_task_author_videos } = data;
          const { form_data: { star_task_author_videos: star_task_author_videos_filed }, custom_config: { star_task_author_videos_filter_config_key }} = this.edit_dialog_config;
          const { filter_config } = star_task_author_videos_filed;
          row[star_task_author_videos_filter_config_key] = filter_config['video_publish_time']?.[advertiser_id] || [];
          creative.star_task_author_videos = star_task_author_videos[advertiser_id].map(({ video_id, video_cover_id, image_mode, item_id }) => ({ video_id, video_cover_id, image_mode, item_id }));
        },
        [`creative_config.creative_components.${CHANNEL_INTERFACE_TYPE.JRTT_V3}`]: () => strategy[`creative_config.creative_components.${CHANNEL_INTERFACE_TYPE.JRTT}`](),
        [`creative_config.creative_components.${CHANNEL_INTERFACE_TYPE.GDT}`]: () => {
          const { advertiser_id, creative } = row;
          const { custom_config: { wxgame_playable_page_path_key }} = this.edit_dialog_config;
          const {
            wxgame_playable_page: {
              wxgame_playable_page_switch,
              wxgame_playable_page_path,
              wxgame_playable_page_end_cover_img,
              wxgame_playable_page_end_desc,
              wxgame_playable_page_trigger_types,
              wxgame_playable_page_trigger_text,
              wxgame_playable_page_card_link_description,
              wxgame_playable_page_card_link_image,
            },
          } = data;

          row[wxgame_playable_page_path_key] = wxgame_playable_page_path;

          if (wxgame_playable_page_switch) {
            Object.assign(creative, { wxgame_playable_pages: {}});
            Object.assign(creative.wxgame_playable_pages, {
              advertiser_id,
              wxgame_playable_page_switch,
              wxgame_playable_page_path: wxgame_playable_page_path[advertiser_id][0].url,
              wxgame_playable_page_end_cover_img,
              wxgame_playable_page_end_desc,
              ...(wxgame_playable_page_trigger_types && { wxgame_playable_page_trigger_types }),
              ...(wxgame_playable_page_trigger_text && { wxgame_playable_page_trigger_text }),
              ...(wxgame_playable_page_card_link_description && { wxgame_playable_page_card_link_description }),
              ...(wxgame_playable_page_card_link_image?.url && { wxgame_playable_page_card_link_image: wxgame_playable_page_card_link_image.url }),
            });
          } else {
            Object.assign(creative, { wxgame_playable_pages: {
              wxgame_playable_page_switch,
            }});
          }
        },
      };

      strategy[`${parent_key}.${children_key}.${channel_interface}`]();
      this.cancelEditDialog();
    },
    /**
     * 关闭表单编辑弹窗
     * @returns {void}
     */
    cancelEditDialog() {
      Object.assign(this.edit_dialog_config, { is_show: false });
    },
    /**
     * 关闭表格所有的Popover
     * @returns {void}
     */
    closeAllTablePopover() {
      for (const key in this.$refs) {
        if (key.indexOf('table_el_popover_ref') !== -1) {
          this.$refs[key]?.doClose?.();
        }
      }
    },
    /**
     * 获取预览表格批量操作选项
     * @returns {Object[]}
     */
    getPreviewBatchOptions(channel_interface) {
      const options_map = {
        sites: {
          label: '批量修改落地页',
          supported_channels: getChannelsWithEditableSite(),
        },
        channel_code: {
          label: '批量修改渠道号',
          supported_channels: getChannelsWithEditableCode(),
        },
      };
      const options = Object.entries(options_map).reduce((pre, [key, { label, supported_channels }]) => {
        return supported_channels.includes(channel_interface) ? pre.concat([{ value: key, label }]) : pre;
      }, []);
      return options;
    },
    /**
     * 预览表格选择事件
     * @returns {void}
     */
    selectionChange(rows) {
      this.table_selected.splice(0);
      this.table_selected.push(...rows);
    },
    /**
     * 批量操作
     * @returns {void}
     */
    onBatch() {
      if (this.table_selected.length === 0) {
        this.$message.warning('请选择需要操作的表格行');
        return;
      }
      if (!this.batch_config.active_name) {
        this.$message.warning('请选择批量操作类型');
        return;
      }
      Object.assign(this.batch_config, {
        is_show: true,
        title: this.batch_config.options.find(({ value }) => value === this.batch_config.active_name).label,
      });
      this.refreshTable();
    },
    /**
     * 批量编辑确认
     * @returns {void}
     */
    onBatchConfirm() {
      this.onBatchCancel();
    },
    /**
     * 批量编辑取消
     * @returns {void}
     */
    onBatchCancel() {
      this.batch_config.is_show = false;
      this.refreshTable();
    },
    /**
     * 获取落地页选择数量限制
     * @returns {number}
     */
    getSitesLimitNum() {
      const { channel_interface } = this.init_ops;
      const strategy = {
        [CHANNEL_INTERFACE_TYPE.GDT]: 3,
        [CHANNEL_INTERFACE_TYPE.JRTT]: 10,
        [CHANNEL_INTERFACE_TYPE.JRTT_V3]: 10,
      };
      return strategy[channel_interface] || 1;
    },
    /**
     * 获取标题选择数量限制
     * @returns {number}
     */
    getTitlesLimitNum() {
      const { channel_interface } = this.init_ops;
      const strategy = {
        [CHANNEL_INTERFACE_TYPE.GDT]: () => {
          const { content_form = {}} = this.formAssignData.creative_config;
          const { titles_num_per_creative = 1 } = content_form;
          return titles_num_per_creative;
        },
        [CHANNEL_INTERFACE_TYPE.BAIDU]: () => {
          const { content_form = {}} = this.formAssignData.creative_config;
          const { titles_num_per_creative = 1 } = content_form;
          return titles_num_per_creative;
        },
        default: () => 1,
      };
      return (strategy[channel_interface] || strategy['default'])();
    },
    /**
     * 处理数值类型属性
     * @param {Object} data 参数
     * @param {Object} data.target 目标数据
     * @param {Object} data.source 源数据
     * @param {Object} data.property 属性键
     * @param {Object} data.multiplier 乘数
     */
    handleNumberProperty({ target, source, property, multiplier = 1 }) {
      if (isNumber(source[property])) {
        Object.assign(target, { [property]: this.times(source[property], multiplier) });
      } else {
        delete target[property];
      }
    },
    /**
     * 设置表单隐藏属性
     * @param {Object} config 表单配置
     * @param {boolean} value 是否隐藏
     * @param {string[]} excludes 排除的字段
     */
    setFormHiddenProp(config, value = true, excludes = []) {
      const setHidden = (key) => {
        if (!excludes.includes(key)) {
          config[key].hidden = value;
        }
      };
      Object.keys(config).forEach((key) => {
        setHidden(key);
        if (config[key].children) {
          setHidden(key);
          this.setFormHiddenProp(config[key].children, value, excludes);
        }
      });
    },
    /**
     * 获取变现ROI或付费ROI数据
     * @param {string} pre_key monetization(变现) | purchase(付费)
     * @param {Object} data 分配的计划数据
     */
    getConvertsFormValues(pre_key, data = {}) {
      const keys = ['convert_goal', 'convert_id', 'convert_name', 'deep_convert_type', 'is_roi'];
      /** 校验对象是否存在某个属性 */
      const hasOwnProperty = (target, key) => Object.prototype.hasOwnProperty.call(target, key);
      return keys.reduce((acc, key) => {
        const value = data[`${pre_key}_${key}`];
        const valid = hasOwnProperty(data, `${pre_key}_${key}`);
        return valid ? { ...acc, [`${pre_key}_${key}`]: value } : acc;
      }, {});
    },
    /**
     * 如果规则集为大于1，则只保留索引为0的规则
     * @param rules 规则集
     */
    deleteConvertsFormRules(rules = []) {
      if (rules.length > 1) {
        rules.splice(1);
      }
    },
    /**
     * 转换变现ROI或付费ROI数据
     * @param {string} pre_key monetization(变现) | purchase(付费)
     * @param {Object} data 分配的计划数据
     */
    transformConvertsFormValues(pre_key, data = {}) {
      const { gdt_params: { is_roi } = {}} = data;
      const keys = ['convert_goal', 'id', 'name', 'deep_convert_goal'];
      const key_map = {
        id: 'convert_id',
        convert_goal: 'convert_goal',
        name: 'convert_name',
        deep_convert_goal: 'deep_convert_type',
        is_roi: 'is_roi',
      };
      return keys.reduce((acc, key) => {
        const value = data[key];
        return value ? { ...acc, [`${pre_key}_${key_map[key]}`]: value } : acc;
      }, isNotNullAndUnDef(is_roi) ? { [`${pre_key}_is_roi`]: is_roi } : {});
    },
    /**
     * 删除变现ROI或付费ROI相关的表单键
     * @param {string} pre_key monetization(变现) | purchase(付费)
     * @param {Object} data 分配的计划数据
     * @returns {void}
     */
    deleteConvertsFormKeys(pre_key, data = {}) {
      const keys = ['convert_goal', 'convert_id', 'convert_name', 'deep_convert_type', 'is_roi'];
      keys.forEach((key) => {
        delete data[`${pre_key}_${key}`];
      });
    },
    /**
     * 处理表格数值类型表单项
     * @param {Object} options 配置项
     * @param {Object} options.data 数据源
     * @param {string} options.property 属性键
     * @param {number} options.dividend 被除数
     */
    handleNumberFiled({ data, filed, property, dividend = 1 }) {
      const has_property = Object.prototype.hasOwnProperty.call(data, property);
      const valid = has_property && isNumber(data[property]);
      filed.hidden = !has_property;
      filed.value = valid ? this.div(data[property], dividend) : (filed.props?.min || 0.01);
    },
    /**
     * 获取投放内容
     * @param {Object} row 当前行数据
     * @returns {Promise<Object[]>}
     */
    async getDeliveryContent(row) {
      try {
        const { channel_interface } = this.init_ops;
        const { advertiser_id, delivery_platform_type } = row.campaign;
        const res = await getDeliveryContentApi({
          channel_interface,
          advertiser_id,
          filtering: {
            delivery_platform_type,
          },
        });
        const list = (res?.list || []).map(({ id, name, ...rest }) => ({ label: name, value: `${id}#${name}`, ...rest }));
        return Promise.resolve(list);
      } catch (error) {
        return Promise.reject(new Error(error));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.preview-table {
  /deep/ .el-table-horizontal-scrollbar {
    transform: scaleY(2);
    filter: brightness(0.1);
    border-radius: 0;
    transform: scaleY(2.25) translateY(-10%);
  }
}
</style>

<style lang="scss">
.smart-delivery-goal {
  display: none;
}
</style>
